import { z } from 'zod';
const JsonValueSchema = z.union([z.string(), z.number(), z.boolean(), z.record(z.any()), z.array(z.any())]);
type JsonValueType = z.infer<typeof JsonValueSchema>;
const Prisma = { AnyNull: null, JsonNull: null, DbNull: null }

// ENUMS
/////////////////////////////////////////

export const TransactionIsolationLevelSchema = z.enum(['ReadUncommitted','ReadCommitted','RepeatableRead','Serializable']);

export const CompanyScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','inboundSlug','name','siret','iban','cgvUrl','logoUrl','quoteNumber','onboardingExitedAt','onboardingActivityType','isInternal','addressId','companySettingsId']);

export const CompanySettingsScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','designOfficeHourlyRate','defaultMaterialPriceUnit','scrapMaterialBillingRate','hasAutoScrapRatio','marginRatio','salesMarginRatio','manHourlyPrice','salesAdministrationHourlyRate','salesAdministrationMarginRatio','designOfficeTime','designOfficeMarginRatio','packingTime','packingMarginRatio','productsMarginRatio','assemblingMarginRatio','quoteExpirationDelay','productsProcessMarginRatio','addedValueProcessMarginRatio','materialMarginRatio','materialsLogisticsCostsRatio','materialPricingMode','nestingMode','hasMultiPartNesting','materialVolumetricPricingStrategy','otherProcessMarginRatio','controlTime','controlHourlyRate','controlMarginRatio','reworkRatio','quoteComment','companyType','timeDisplayFormat','forceCompanyTypeForConsumables','authorizeConsumable','quoteTemplate','areQuotesERPExportable','exportTemplateId','exportTemplateJson','assemblySplitMode','isBetaTester','shouldDisplayChildrenAsSearchResults','similarityThreshold','webhookUrl','hasCustomInputs','sheetCutWidthFormula','sheetSkeletonWidthFormula','machiningCutWidthFormula','machiningSkeletonWidthFormula','turningCutWidthFormula','turningChuckGripFormula','machiningOverThicknessLengthFormula','machiningOverThicknessWidthFormula','machiningOverThicknessHeightFormula','sheetOverThicknessLengthFormula','sheetOverThicknessWidthFormula','sheetOverThicknessHeightFormula','turningOverThicknessLengthFormula','turningOverThicknessDiameterFormula','defaultTransportIsOutsourced','defaultTransportShouldDistributeCost','defaultTransportCalculationMethod','partTypeMapperOverride','defaultSheetFormat','modelId']);

export const CompanySurfaceTreatmentScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','description','method','price','formula','preparationTimeFormula','cycleTimeFormula','type','industrialProcess','companySettingsId']);

export const PermissionScalarFieldEnumSchema = z.enum(['id','name','description','defaultValue']);

export const CompanyPermissionScalarFieldEnumSchema = z.enum(['value','companyId','permissionId']);

export const UserScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','lastLoginAt','email','firstName','lastName','password','isDisabled','role','companyId','userSettingsId']);

export const UserSettingsScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','quoteFollowUpEnabled','outlookConnectionEnabled']);

export const ClientScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','name','emailDomain','siret','erpCode','comment','companyId']);

export const ContactScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','firstName','lastName','email','phone','clientId']);

export const AddressScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','street','zipCode','city','country','clientId']);

export const QuoteRequestScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','mailId','version','reference','clientReference','status','isArchived','orderType','targetPrice','expirationDate','discountRatio','salesMarginRatio','shippingPriority','nCompaniesRequested','foreignCompaniesRequested','alreadyManufacturedParts','salesAdministrationTime','salesAdministrationHourlyRate','salesAdministrationMarginRatio','certificationNeeded','skippedFollowUp','certificateCost','quoteSentAt','dueDate','isFavorite','priority','comment','clientNote','isImported','internalId','createdById','shippingAddressId','billingAddressId','companyId','clientId','contactId','ownerId']);

export const QuoteRequestLineScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','quotedAt','shippingDelay','index','quantity','materialGrade','materialName','comment','internalComment','designOfficeTime','designOfficeHourlyRate','designOfficeMarginRatio','reworkRatio','productsMarginRatio','materialMarginRatio','addedValueMarginRatio','status','declineReason','isReliable','internalId','predictionStatus','usedInModel','partId','quoteRequestId','copiedFromId','batchId','assemblyParentId','layoutId']);

export const BatchScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','partId','quoteRequestId','referenceLineId']);

export const QuoteScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','version','marginRatio','discountRatio','salesMarginRatio','deliveryTime','manHourlyRate','expirationDate','vat','priceHt','pdfFileUrl','createdById','quoteRequestId','companyId']);

export const ProductScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','name','price','fixedPrice','type','companyId','companySettingsId']);

export const ProductLineScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','isQuantityPerPart','quantity','name','price','fixedPrice','productId','quoteRequestLineId','processStepId','quoteRequestId']);

export const PartScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','name','clientReference','internalReference','hasEmbedding','hasTopologicalEmbedding','hasDrawingEmbedding','featuresJson','type','subType','heightOverride','widthOverride','lengthOverride','tubeThicknessOverride','weightOverride','quantityInAssemblyOverride','featuresJsonOverride','parentId','rootParentId','companyId']);

export const FileScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','url','name','hash','size','type','companyId','partId']);

export const PartAnalysisScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','source','urlGltf','urlPng','urlPdfAnnotated','urlPdfPreview','materialGrade','materialName','surfaceTreatments','height','width','length','tubeThickness','volume','weight','area','boundingBoxX','boundingBoxY','boundingBoxZ','boundingBoxVolume','boundingBoxArea','gltfStatus','previewStatus','pdfPreviewStatus','embeddingStatus','featuresStatus','graphStatus','analyzeStatus','analyze2DStatus','topologicalEmbeddingStatus','drawingEmbeddingStatus','drawingAnalyticExtractionStatus','drawingLLMExtractionStatus','flatPatternStatus','tolerance','partJson','isPartJsonReconstructed','graphUrl','graphVersion','analyze2DJson','flatPattern','quantityInAssembly','fileId']);

export const ProcessStepScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','mode','industrialProcess','index','description','margin','toolingCost','otherMachineTime','modelCycleTime','abacusCycleTime','sourceCycleTime','machinePreparationTime','machineHourlyPrice','manTime','manHourlyPrice','alerts','isFixedCostPerSeries','fixedCost','isFixedCostManuallyEdited','fixedCostPerSeries','materialLoadTimeMinutes','partLoadTimeMinutes','materialUnloadingTime','partsToPackQuantity','minimumOrderAmount','productsMarginRatio','packingHourlyPrice','partsToControlRatio','isMaterialLayoutPerPart','isOutsourced','cycleTimeCost','machinePreparationTimeCost','materialLayoutId','predictionId','companyMachineId','quoteRequestLineId','quoteRequestId']);

export const DefaultProcessStepScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','index','industrialProcess','description','partLevels','preparationTimeFormula','cycleTimeFormula','machineHourlyPrice','companySettingsId']);

export const MachineScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','internalId','brand','name','industrialProcess','companyId']);

export const CompanyMachineScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','deletedAt','machineHourlyPrice','cycleTimeFormula','preparationTimeFormula','materialLoadTimeMinutes','marginRatio','modelProcessStepDescription','processStepDescriptionOverride','canBeOptimized','companyId','machineId']);

export const MaterialScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','internalId','name','type','subType','height','width','length','tubeThickness','density','materialGrade','price','companyId']);

export const MaterialVolumetricScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','materialGrade','name','volumetricPrice','companyId']);

export const MaterialLayoutScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','length','tubeThickness','width','height','price','pricingMode','volume','volumetricPrice','density','quantity','maxPartsPerLayout','type','materialId','materialVolumetricId','layoutId']);

export const LayoutScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','useNesting','cutWidth','skeletonWidth','scrapRatio','scrapMaterialBillingRate','newScrapMaterialBillingRate','margin','materialsLogisticsCostsRatio','hasAutoScrapRatio','status','quoteRequestId','appliedNestingRunId']);

export const NestingRunScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','status','isFallback','sheetsUsed','consumedAreaMm2','solution','layouts','warnings','errorCode','errorItemId','simpleNestingSheetCapacity','layoutId']);

export const OptimizationScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','deletedAt','type','enabled','quoteRequestId']);

export const OptimizationNotificationScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','type','readAt','partId','optimizationId']);

export const SheetNestingOptimizationMetadataScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','height','materialGrade','materialName','optimizationId','layoutId']);

export const MachineTimesOptimizationMetadataScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','height','width','length','tubeThickness','materialGrade','materialName','machinePreparationTime','otherMachineTime','companyMachineId','optimizationId']);

export const ModelScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','name','key','type','drawingExtractionMethod']);

export const PredictionScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','modelVersion','graphUrl','apiRequest','apiResponse','inputHash','quoteRequestLineId']);

export const PredictionFeedbackScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','rating','comment','causes','actualMaterialPrice','actualAddedValuePrice','actualTotalPrice','predictionId','userId']);

export const SimilarPartFeedbackScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','rating','index','userId','sourcePartId','targetPartId']);

export const ClusterScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','sourceQuoteRequestLineId']);

export const CustomInputScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','modelVersion','key','label','value','quoteRequestLineId']);

export const JobScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','externalId','type','subType','status','inputPayload','outputPayload','rawErrorMessage','errorMetadata','errorCode','partAnalysisId','quoteRequestLineId','quoteRequestId','companyId']);

export const PartAnalyticsScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','partVolumeMin','partVolumeMax','partAreaMin','partAreaMax','companyId']);

export const MaterialAnalyticsScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','materialGrade','volumetricPriceMin','volumetricPriceMax','companyId']);

export const ResetPasswordTokenScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','userId']);

export const OAuthAccountScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','provider','accessToken','refreshToken','expiresOn','msTenantId','userId']);

export const PkceChallengeScalarFieldEnumSchema = z.enum(['nonce','createdAt','verifier','expiresAt']);

export const McpAuthorizationCodeScalarFieldEnumSchema = z.enum(['id','createdAt','code','codeChallenge','redirectUri','expiresAt','userId']);

export const QuoteRequestNotificationsDelayScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','quoteRequestStatus','delay','userSettingsId']);

export const SearchScalarFieldEnumSchema = z.enum(['id','createdAt','updatedAt','query','userId']);

export const InboundEmailScalarFieldEnumSchema = z.enum(['id','createdAt','emailId','svixId']);

export const SettingsAuditLogScalarFieldEnumSchema = z.enum(['id','createdAt','tableName','recordId','companyId','operation','oldData','newData','dbRole','actorType','actorId','actorLabel']);

export const SortOrderSchema = z.enum(['asc','desc']);

export const NullableJsonNullValueInputSchema = z.enum(['DbNull','JsonNull',]).transform((value) => value === 'JsonNull' ? Prisma.JsonNull : value === 'DbNull' ? Prisma.DbNull : value);

export const JsonNullValueInputSchema = z.enum(['JsonNull',]).transform((value) => (value === 'JsonNull' ? Prisma.JsonNull : value));

export const QueryModeSchema = z.enum(['default','insensitive']);

export const NullsOrderSchema = z.enum(['first','last']);

export const JsonNullValueFilterSchema = z.enum(['DbNull','JsonNull','AnyNull',]).transform((value) => value === 'JsonNull' ? Prisma.JsonNull : value === 'DbNull' ? Prisma.JsonNull : value === 'AnyNull' ? Prisma.AnyNull : value);

export const OnboardingActivityTypeSchema = z.enum(['SHEET','BOILERMAKING','MACHINING']);

export type OnboardingActivityTypeType = `${z.infer<typeof OnboardingActivityTypeSchema>}`

export const PricingModeSchema = z.enum(['RAW','VOLUMETRIC']);

export type PricingModeType = `${z.infer<typeof PricingModeSchema>}`

export const NestingModeSchema = z.enum(['AUTOMATIC','ALWAYS','NEVER']);

export type NestingModeType = `${z.infer<typeof NestingModeSchema>}`

export const MaterialVolumetricPricingStrategySchema = z.enum(['REAL_WEIGHT','CAPABLE_RECTANGLE']);

export type MaterialVolumetricPricingStrategyType = `${z.infer<typeof MaterialVolumetricPricingStrategySchema>}`

export const CompanyTypeSchema = z.enum(['SHEET','MACHINING','TURNING']);

export type CompanyTypeType = `${z.infer<typeof CompanyTypeSchema>}`

export const TimeDisplayFormatSchema = z.enum(['HH_MM_SS','DECIMAL_MINUTES','DECIMAL_HOURS']);

export type TimeDisplayFormatType = `${z.infer<typeof TimeDisplayFormatSchema>}`

export const AssemblySplitModeSchema = z.enum(['ROOT','LEAF','ALL']);

export type AssemblySplitModeType = `${z.infer<typeof AssemblySplitModeSchema>}`

export const TransportCalculationMethodSchema = z.enum(['FIXED','WEIGHT']);

export type TransportCalculationMethodType = `${z.infer<typeof TransportCalculationMethodSchema>}`

export const SurfaceTreatmentMethodSchema = z.enum(['m2','m3','kg','fixed','formula','time']);

export type SurfaceTreatmentMethodType = `${z.infer<typeof SurfaceTreatmentMethodSchema>}`

export const SurfaceTreatmentTypeSchema = z.enum(['OUTSOURCING','INHOUSE']);

export type SurfaceTreatmentTypeType = `${z.infer<typeof SurfaceTreatmentTypeSchema>}`

export const RoleSchema = z.enum(['SUPER_ADMIN','ADMIN','SALES','VIEWER']);

export type RoleType = `${z.infer<typeof RoleSchema>}`

export const QuoteRequestStatusSchema = z.enum(['DRAFT','NEW','ESTIMATING','ESTIMATED','TO_VALIDATE','TO_SEND','SENT','ACCEPTED','REFUSED','DECLINED']);

export type QuoteRequestStatusType = `${z.infer<typeof QuoteRequestStatusSchema>}`

export const OrderTypeSchema = z.enum(['RECURRING','ONE_OFF_EMERGENCY','QUOTING_FOR_PLANNING']);

export type OrderTypeType = `${z.infer<typeof OrderTypeSchema>}`

export const ShippingPrioritySchema = z.enum(['HIGH','LOW']);

export type ShippingPriorityType = `${z.infer<typeof ShippingPrioritySchema>}`

export const PrioritySchema = z.enum(['HIGH','MEDIUM','LOW']);

export type PriorityType = `${z.infer<typeof PrioritySchema>}`

export const QuoteRequestLineStatusSchema = z.enum(['DECLINED','DRAFT','COPIED','QUOTED']);

export type QuoteRequestLineStatusType = `${z.infer<typeof QuoteRequestLineStatusSchema>}`

export const ProductTypeSchema = z.enum(['PACKING','CONSUMABLE','OUTSOURCING','CHILD']);

export type ProductTypeType = `${z.infer<typeof ProductTypeSchema>}`

export const PartTypeSchema = z.enum(['ASSEMBLY','SHEET','MACHINING','ROUND_TUBE','SQUARE_TUBE','RECTANGULAR_TUBE','ROUND_BAR','SQUARE_BAR','CONSUMABLE','PROFILE','OTHER']);

export type PartTypeType = `${z.infer<typeof PartTypeSchema>}`

export const FileTypeSchema = z.enum(['PART','COMPANY_LOGO','COMPANY_CGV','MATERIALS_PRICING','MATERIALS','ONBOARDING','QUOTE_PDF','EMAIL_REQUEST_SPREADSHEET','EMAIL_REQUEST_CONTENT']);

export type FileTypeType = `${z.infer<typeof FileTypeSchema>}`

export const PartAnalysisSourceSchema = z.enum(['PYCAD','PYPLAN']);

export type PartAnalysisSourceType = `${z.infer<typeof PartAnalysisSourceSchema>}`

export const ProcessStepModeSchema = z.enum(['TIME','PREDICTION']);

export type ProcessStepModeType = `${z.infer<typeof ProcessStepModeSchema>}`

export const IndustrialProcessSchema = z.enum(['ASSEMBLING','BENDING','CHIMIC_ENGRAVING','COMBINED_PUNCHING_LASER','CONTROL','COUNTERSINKING','CRIMPING','DEBURRING','DRILLING','ELECTRO_EROSION','ENGRAVING','FOLDING','GRINDING','HEAT_TREATMENT','LASER_CUT','MATERIAL','MILLING','OTHER','OUTSOURCING','PACKING','PLASMA_CUT','PRESSING','PRODUCTS','PUNCHING','RIVETING','ROLLING','SAWING','SHEARING','SIMPLE','SURFACE_TREATMENT','TAPPING','TRANSPORT','TRIMMING','TURNING','UNSTAPLING','WATER_CUT','WELDING']);

export type IndustrialProcessType = `${z.infer<typeof IndustrialProcessSchema>}`

export const SourceCycleTimeSchema = z.enum(['ABACUS','MODEL']);

export type SourceCycleTimeType = `${z.infer<typeof SourceCycleTimeSchema>}`

export const PartLevelSchema = z.enum(['PARENT','CHILD','ORPHELIN']);

export type PartLevelType = `${z.infer<typeof PartLevelSchema>}`

export const RecommendationTypeSchema = z.enum(['LASER_CUT_FAST','LASER_CUT_PRIMERS_SPEED','LINEAR_SPEED_MM_S','ACTION_PER_MINUTE']);

export type RecommendationTypeType = `${z.infer<typeof RecommendationTypeSchema>}`

export const MaterialTypeSchema = z.enum(['SHEET','ROUND_TUBE','SQUARE_TUBE','RECTANGULAR_TUBE','ROUND_BAR','SQUARE_BAR','PROFILE','OTHER']);

export type MaterialTypeType = `${z.infer<typeof MaterialTypeSchema>}`

export const MaterialGradeSchema = z.enum(['ALUMINIUM','BRASS','COPPER','GALVANIZED_STEEL','STAINLESS_STEEL','STEEL','STEEL_PRE_LACQUERED','STEEL_COLD_ROLLED_CORTEN','STEEL_HOT_ROLLED_CORTEN','ZINC','BRONZE','PLASTIC','CAST_IRON','RUBBER','MAGNESIUM','TITANIUM','COMPOSITE','WOOD','INCONEL','OTHER']);

export type MaterialGradeType = `${z.infer<typeof MaterialGradeSchema>}`

export const ProcessableMaterialFormatSchema = z.enum(['SHEET','TUBE','BEAM']);

export type ProcessableMaterialFormatType = `${z.infer<typeof ProcessableMaterialFormatSchema>}`

export const SheetSizeSchema = z.enum(['L2000W1000','L2500W1250','L3000W1500','OTHER']);

export type SheetSizeType = `${z.infer<typeof SheetSizeSchema>}`

export const LayoutStatusSchema = z.enum(['DRAFT','VALIDATED']);

export type LayoutStatusType = `${z.infer<typeof LayoutStatusSchema>}`

export const OptimizationTypeSchema = z.enum(['SHEET_NESTING','MACHINE_TIMES']);

export type OptimizationTypeType = `${z.infer<typeof OptimizationTypeSchema>}`

export const OptimizationNotificationTypeSchema = z.enum(['DELETED_LINE']);

export type OptimizationNotificationTypeType = `${z.infer<typeof OptimizationNotificationTypeSchema>}`

export const PredictionModelTypeSchema = z.enum(['V2','CLUSTERING','MULTI_MODAL']);

export type PredictionModelTypeType = `${z.infer<typeof PredictionModelTypeSchema>}`

export const DrawingExtractionMethodSchema = z.enum(['LLM_EXTRACTION','ANALYTIC_EXTRACTION','BOTH']);

export type DrawingExtractionMethodType = `${z.infer<typeof DrawingExtractionMethodSchema>}`

export const PredictionFeedbackCauseSchema = z.enum(['FAULTY_MODEL','INCORRECT_MATERIAL_DATA','WRONG_MACHINE_SETTINGS','WRONG_PART_TYPE_DETECTED','REGRESSION_AFTER_UPDATE','INSUFFICIENT_TRAINING_DATA','NOT_IDENTIFIED']);

export type PredictionFeedbackCauseType = `${z.infer<typeof PredictionFeedbackCauseSchema>}`

export const JobTypeSchema = z.enum(['ANALYZE','ANALYZE2D','PREDICT','INBOUND_EMAIL_EXTRACTION','MATERIAL_BASE_STRUCTURATION']);

export type JobTypeType = `${z.infer<typeof JobTypeSchema>}`

export const JobSubTypeSchema = z.enum(['GLTF','PREVIEW','FEATURES','GRAPH','TOPOLOGICAL_EMBEDDING','FLAT_PATTERN','DRAWING_EMBEDDING','DRAWING_ANALYTIC_EXTRACTION','DRAWING_LLM_EXTRACTION','DRAWING_PREVIEW']);

export type JobSubTypeType = `${z.infer<typeof JobSubTypeSchema>}`

export const JobStatusSchema = z.enum(['PENDING','STANDBY','PROCESSING','PROCESSED','ERROR']);

export type JobStatusType = `${z.infer<typeof JobStatusSchema>}`

export const JobErrorCodeSchema = z.enum(['UNKNOWN_ERROR','JOB_TIMEOUT','UNPROCESSABLE_DATA','INVALID_INPUT']);

export type JobErrorCodeType = `${z.infer<typeof JobErrorCodeSchema>}`

export const EmailRequestStatusSchema = z.enum(['NEW','COMPLETED']);

export type EmailRequestStatusType = `${z.infer<typeof EmailRequestStatusSchema>}`

export const AuditOperationSchema = z.enum(['INSERT','UPDATE','DELETE']);

export type AuditOperationType = `${z.infer<typeof AuditOperationSchema>}`

export const AuditActorTypeSchema = z.enum(['CUSTOMER','FABERA_ADMIN','EXTERNAL_API','SYSTEM']);

export type AuditActorTypeType = `${z.infer<typeof AuditActorTypeSchema>}`

/////////////////////////////////////////
// MODELS
/////////////////////////////////////////

/////////////////////////////////////////
// COMPANY SCHEMA
/////////////////////////////////////////

export const CompanySchema = z.object({
  onboardingActivityType: OnboardingActivityTypeSchema.nullable(),
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  inboundSlug: z.string(),
  name: z.string(),
  siret: z.string().nullable(),
  iban: z.string().nullable(),
  cgvUrl: z.string().nullable(),
  logoUrl: z.string().nullable(),
  quoteNumber: z.number().int(),
  onboardingExitedAt: z.coerce.date().nullable(),
  isInternal: z.boolean(),
  addressId: z.string(),
  companySettingsId: z.string(),
})

export type Company = z.infer<typeof CompanySchema>

// COMPANY OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const CompanyOptionalDefaultsSchema = CompanySchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  inboundSlug: z.string().optional(),
  quoteNumber: z.number().int().optional(),
  isInternal: z.boolean().optional(),
}))

export type CompanyOptionalDefaults = z.infer<typeof CompanyOptionalDefaultsSchema>

// COMPANY RELATION SCHEMA
//------------------------------------------------------

export type CompanyRelations = {
  address: AddressWithRelations;
  companySettings: CompanySettingsWithRelations;
  partAnalytics?: PartAnalyticsWithRelations | null;
  companyMachines: CompanyMachineWithRelations[];
  products: ProductWithRelations[];
  users: UserWithRelations[];
  quoteRequests: QuoteRequestWithRelations[];
  quotes: QuoteWithRelations[];
  clients: ClientWithRelations[];
  Machine: MachineWithRelations[];
  Part: PartWithRelations[];
  permissions: CompanyPermissionWithRelations[];
  MaterialVolumetric: MaterialVolumetricWithRelations[];
  materials: MaterialWithRelations[];
  files: FileWithRelations[];
  materialAnalytics: MaterialAnalyticsWithRelations[];
  jobs: JobWithRelations[];
};

export type CompanyWithRelations = z.infer<typeof CompanySchema> & CompanyRelations

export const CompanyWithRelationsSchema: z.ZodType<CompanyWithRelations> = CompanySchema.merge(z.object({
  address: z.lazy(() => AddressWithRelationsSchema),
  companySettings: z.lazy(() => CompanySettingsWithRelationsSchema),
  partAnalytics: z.lazy(() => PartAnalyticsWithRelationsSchema).nullable(),
  companyMachines: z.lazy(() => CompanyMachineWithRelationsSchema).array(),
  products: z.lazy(() => ProductWithRelationsSchema).array(),
  users: z.lazy(() => UserWithRelationsSchema).array(),
  quoteRequests: z.lazy(() => QuoteRequestWithRelationsSchema).array(),
  quotes: z.lazy(() => QuoteWithRelationsSchema).array(),
  clients: z.lazy(() => ClientWithRelationsSchema).array(),
  Machine: z.lazy(() => MachineWithRelationsSchema).array(),
  Part: z.lazy(() => PartWithRelationsSchema).array(),
  permissions: z.lazy(() => CompanyPermissionWithRelationsSchema).array(),
  MaterialVolumetric: z.lazy(() => MaterialVolumetricWithRelationsSchema).array(),
  materials: z.lazy(() => MaterialWithRelationsSchema).array(),
  files: z.lazy(() => FileWithRelationsSchema).array(),
  materialAnalytics: z.lazy(() => MaterialAnalyticsWithRelationsSchema).array(),
  jobs: z.lazy(() => JobWithRelationsSchema).array(),
}))

// COMPANY OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type CompanyOptionalDefaultsRelations = {
  address: AddressOptionalDefaultsWithRelations;
  companySettings: CompanySettingsOptionalDefaultsWithRelations;
  partAnalytics?: PartAnalyticsOptionalDefaultsWithRelations | null;
  companyMachines: CompanyMachineOptionalDefaultsWithRelations[];
  products: ProductOptionalDefaultsWithRelations[];
  users: UserOptionalDefaultsWithRelations[];
  quoteRequests: QuoteRequestOptionalDefaultsWithRelations[];
  quotes: QuoteOptionalDefaultsWithRelations[];
  clients: ClientOptionalDefaultsWithRelations[];
  Machine: MachineOptionalDefaultsWithRelations[];
  Part: PartOptionalDefaultsWithRelations[];
  permissions: CompanyPermissionOptionalDefaultsWithRelations[];
  MaterialVolumetric: MaterialVolumetricOptionalDefaultsWithRelations[];
  materials: MaterialOptionalDefaultsWithRelations[];
  files: FileOptionalDefaultsWithRelations[];
  materialAnalytics: MaterialAnalyticsOptionalDefaultsWithRelations[];
  jobs: JobOptionalDefaultsWithRelations[];
};

export type CompanyOptionalDefaultsWithRelations = z.infer<typeof CompanyOptionalDefaultsSchema> & CompanyOptionalDefaultsRelations

export const CompanyOptionalDefaultsWithRelationsSchema: z.ZodType<CompanyOptionalDefaultsWithRelations> = CompanyOptionalDefaultsSchema.merge(z.object({
  address: z.lazy(() => AddressOptionalDefaultsWithRelationsSchema),
  companySettings: z.lazy(() => CompanySettingsOptionalDefaultsWithRelationsSchema),
  partAnalytics: z.lazy(() => PartAnalyticsOptionalDefaultsWithRelationsSchema).nullable(),
  companyMachines: z.lazy(() => CompanyMachineOptionalDefaultsWithRelationsSchema).array(),
  products: z.lazy(() => ProductOptionalDefaultsWithRelationsSchema).array(),
  users: z.lazy(() => UserOptionalDefaultsWithRelationsSchema).array(),
  quoteRequests: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema).array(),
  quotes: z.lazy(() => QuoteOptionalDefaultsWithRelationsSchema).array(),
  clients: z.lazy(() => ClientOptionalDefaultsWithRelationsSchema).array(),
  Machine: z.lazy(() => MachineOptionalDefaultsWithRelationsSchema).array(),
  Part: z.lazy(() => PartOptionalDefaultsWithRelationsSchema).array(),
  permissions: z.lazy(() => CompanyPermissionOptionalDefaultsWithRelationsSchema).array(),
  MaterialVolumetric: z.lazy(() => MaterialVolumetricOptionalDefaultsWithRelationsSchema).array(),
  materials: z.lazy(() => MaterialOptionalDefaultsWithRelationsSchema).array(),
  files: z.lazy(() => FileOptionalDefaultsWithRelationsSchema).array(),
  materialAnalytics: z.lazy(() => MaterialAnalyticsOptionalDefaultsWithRelationsSchema).array(),
  jobs: z.lazy(() => JobOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// COMPANY SETTINGS SCHEMA
/////////////////////////////////////////

export const CompanySettingsSchema = z.object({
  materialPricingMode: PricingModeSchema,
  nestingMode: NestingModeSchema,
  materialVolumetricPricingStrategy: MaterialVolumetricPricingStrategySchema,
  companyType: CompanyTypeSchema.nullable(),
  timeDisplayFormat: TimeDisplayFormatSchema,
  assemblySplitMode: AssemblySplitModeSchema,
  defaultTransportCalculationMethod: TransportCalculationMethodSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  designOfficeHourlyRate: z.number().int(),
  defaultMaterialPriceUnit: z.string().nullable(),
  scrapMaterialBillingRate: z.number(),
  hasAutoScrapRatio: z.boolean(),
  marginRatio: z.number().nullable(),
  salesMarginRatio: z.number().nullable(),
  manHourlyPrice: z.number().int(),
  salesAdministrationHourlyRate: z.number().int(),
  salesAdministrationMarginRatio: z.number(),
  designOfficeTime: z.number(),
  designOfficeMarginRatio: z.number(),
  packingTime: z.number(),
  packingMarginRatio: z.number(),
  productsMarginRatio: z.number(),
  assemblingMarginRatio: z.number(),
  quoteExpirationDelay: z.number().int(),
  productsProcessMarginRatio: z.number().int(),
  addedValueProcessMarginRatio: z.number().int(),
  materialMarginRatio: z.number(),
  materialsLogisticsCostsRatio: z.number(),
  hasMultiPartNesting: z.boolean(),
  otherProcessMarginRatio: z.number(),
  controlTime: z.number(),
  controlHourlyRate: z.number().int(),
  controlMarginRatio: z.number(),
  reworkRatio: z.number(),
  quoteComment: z.string().nullable(),
  forceCompanyTypeForConsumables: z.boolean(),
  authorizeConsumable: z.boolean(),
  quoteTemplate: z.string().nullable(),
  areQuotesERPExportable: z.boolean(),
  exportTemplateId: z.string().nullable(),
  exportTemplateJson: JsonValueSchema.nullable(),
  isBetaTester: z.boolean(),
  shouldDisplayChildrenAsSearchResults: z.boolean(),
  similarityThreshold: z.number(),
  webhookUrl: z.string().nullable(),
  hasCustomInputs: z.boolean(),
  sheetCutWidthFormula: z.string(),
  sheetSkeletonWidthFormula: z.string(),
  machiningCutWidthFormula: z.string(),
  machiningSkeletonWidthFormula: z.string(),
  turningCutWidthFormula: z.string(),
  turningChuckGripFormula: z.string(),
  machiningOverThicknessLengthFormula: z.string(),
  machiningOverThicknessWidthFormula: z.string(),
  machiningOverThicknessHeightFormula: z.string(),
  sheetOverThicknessLengthFormula: z.string(),
  sheetOverThicknessWidthFormula: z.string(),
  sheetOverThicknessHeightFormula: z.string(),
  turningOverThicknessLengthFormula: z.string(),
  turningOverThicknessDiameterFormula: z.string(),
  defaultTransportIsOutsourced: z.boolean(),
  defaultTransportShouldDistributeCost: z.boolean(),
  partTypeMapperOverride: JsonValueSchema.nullable(),
  defaultSheetFormat: JsonValueSchema.nullable(),
  modelId: z.string().nullable(),
})

export type CompanySettings = z.infer<typeof CompanySettingsSchema>

// COMPANY SETTINGS OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const CompanySettingsOptionalDefaultsSchema = CompanySettingsSchema.merge(z.object({
  materialPricingMode: PricingModeSchema.optional(),
  nestingMode: NestingModeSchema.optional(),
  materialVolumetricPricingStrategy: MaterialVolumetricPricingStrategySchema.optional(),
  timeDisplayFormat: TimeDisplayFormatSchema.optional(),
  assemblySplitMode: AssemblySplitModeSchema.optional(),
  defaultTransportCalculationMethod: TransportCalculationMethodSchema.optional(),
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  designOfficeHourlyRate: z.number().int().optional(),
  scrapMaterialBillingRate: z.number().optional(),
  hasAutoScrapRatio: z.boolean().optional(),
  manHourlyPrice: z.number().int().optional(),
  salesAdministrationHourlyRate: z.number().int().optional(),
  salesAdministrationMarginRatio: z.number().optional(),
  designOfficeTime: z.number().optional(),
  designOfficeMarginRatio: z.number().optional(),
  packingTime: z.number().optional(),
  packingMarginRatio: z.number().optional(),
  productsMarginRatio: z.number().optional(),
  assemblingMarginRatio: z.number().optional(),
  quoteExpirationDelay: z.number().int().optional(),
  productsProcessMarginRatio: z.number().int().optional(),
  addedValueProcessMarginRatio: z.number().int().optional(),
  materialMarginRatio: z.number().optional(),
  materialsLogisticsCostsRatio: z.number().optional(),
  hasMultiPartNesting: z.boolean().optional(),
  otherProcessMarginRatio: z.number().optional(),
  controlTime: z.number().optional(),
  controlHourlyRate: z.number().int().optional(),
  controlMarginRatio: z.number().optional(),
  reworkRatio: z.number().optional(),
  forceCompanyTypeForConsumables: z.boolean().optional(),
  authorizeConsumable: z.boolean().optional(),
  areQuotesERPExportable: z.boolean().optional(),
  isBetaTester: z.boolean().optional(),
  shouldDisplayChildrenAsSearchResults: z.boolean().optional(),
  similarityThreshold: z.number().optional(),
  hasCustomInputs: z.boolean().optional(),
  sheetCutWidthFormula: z.string().optional(),
  sheetSkeletonWidthFormula: z.string().optional(),
  machiningCutWidthFormula: z.string().optional(),
  machiningSkeletonWidthFormula: z.string().optional(),
  turningCutWidthFormula: z.string().optional(),
  turningChuckGripFormula: z.string().optional(),
  machiningOverThicknessLengthFormula: z.string().optional(),
  machiningOverThicknessWidthFormula: z.string().optional(),
  machiningOverThicknessHeightFormula: z.string().optional(),
  sheetOverThicknessLengthFormula: z.string().optional(),
  sheetOverThicknessWidthFormula: z.string().optional(),
  sheetOverThicknessHeightFormula: z.string().optional(),
  turningOverThicknessLengthFormula: z.string().optional(),
  turningOverThicknessDiameterFormula: z.string().optional(),
  defaultTransportIsOutsourced: z.boolean().optional(),
  defaultTransportShouldDistributeCost: z.boolean().optional(),
}))

export type CompanySettingsOptionalDefaults = z.infer<typeof CompanySettingsOptionalDefaultsSchema>

// COMPANY SETTINGS RELATION SCHEMA
//------------------------------------------------------

export type CompanySettingsRelations = {
  model?: ModelWithRelations | null;
  company?: CompanyWithRelations | null;
  defaultProducts: ProductWithRelations[];
  surfaceTreatments: CompanySurfaceTreatmentWithRelations[];
  defaultProcessSteps: DefaultProcessStepWithRelations[];
};

export type CompanySettingsWithRelations = Omit<z.infer<typeof CompanySettingsSchema>, "exportTemplateJson" | "partTypeMapperOverride" | "defaultSheetFormat"> & {
  exportTemplateJson?: JsonValueType | null;
  partTypeMapperOverride?: JsonValueType | null;
  defaultSheetFormat?: JsonValueType | null;
} & CompanySettingsRelations

export const CompanySettingsWithRelationsSchema: z.ZodType<CompanySettingsWithRelations> = CompanySettingsSchema.merge(z.object({
  model: z.lazy(() => ModelWithRelationsSchema).nullable(),
  company: z.lazy(() => CompanyWithRelationsSchema).nullable(),
  defaultProducts: z.lazy(() => ProductWithRelationsSchema).array(),
  surfaceTreatments: z.lazy(() => CompanySurfaceTreatmentWithRelationsSchema).array(),
  defaultProcessSteps: z.lazy(() => DefaultProcessStepWithRelationsSchema).array(),
}))

// COMPANY SETTINGS OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type CompanySettingsOptionalDefaultsRelations = {
  model?: ModelOptionalDefaultsWithRelations | null;
  company?: CompanyOptionalDefaultsWithRelations | null;
  defaultProducts: ProductOptionalDefaultsWithRelations[];
  surfaceTreatments: CompanySurfaceTreatmentOptionalDefaultsWithRelations[];
  defaultProcessSteps: DefaultProcessStepOptionalDefaultsWithRelations[];
};

export type CompanySettingsOptionalDefaultsWithRelations = Omit<z.infer<typeof CompanySettingsOptionalDefaultsSchema>, "exportTemplateJson" | "partTypeMapperOverride" | "defaultSheetFormat"> & {
  exportTemplateJson?: JsonValueType | null;
  partTypeMapperOverride?: JsonValueType | null;
  defaultSheetFormat?: JsonValueType | null;
} & CompanySettingsOptionalDefaultsRelations

export const CompanySettingsOptionalDefaultsWithRelationsSchema: z.ZodType<CompanySettingsOptionalDefaultsWithRelations> = CompanySettingsOptionalDefaultsSchema.merge(z.object({
  model: z.lazy(() => ModelOptionalDefaultsWithRelationsSchema).nullable(),
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema).nullable(),
  defaultProducts: z.lazy(() => ProductOptionalDefaultsWithRelationsSchema).array(),
  surfaceTreatments: z.lazy(() => CompanySurfaceTreatmentOptionalDefaultsWithRelationsSchema).array(),
  defaultProcessSteps: z.lazy(() => DefaultProcessStepOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// COMPANY SURFACE TREATMENT SCHEMA
/////////////////////////////////////////

export const CompanySurfaceTreatmentSchema = z.object({
  method: SurfaceTreatmentMethodSchema,
  type: SurfaceTreatmentTypeSchema,
  industrialProcess: IndustrialProcessSchema.nullable(),
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  description: z.string(),
  price: z.number().int().nullable(),
  formula: z.string().nullable(),
  preparationTimeFormula: z.string().nullable(),
  cycleTimeFormula: z.string().nullable(),
  companySettingsId: z.string(),
})

export type CompanySurfaceTreatment = z.infer<typeof CompanySurfaceTreatmentSchema>

// COMPANY SURFACE TREATMENT OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const CompanySurfaceTreatmentOptionalDefaultsSchema = CompanySurfaceTreatmentSchema.merge(z.object({
  type: SurfaceTreatmentTypeSchema.optional(),
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type CompanySurfaceTreatmentOptionalDefaults = z.infer<typeof CompanySurfaceTreatmentOptionalDefaultsSchema>

// COMPANY SURFACE TREATMENT RELATION SCHEMA
//------------------------------------------------------

export type CompanySurfaceTreatmentRelations = {
  companySettings: CompanySettingsWithRelations;
};

export type CompanySurfaceTreatmentWithRelations = z.infer<typeof CompanySurfaceTreatmentSchema> & CompanySurfaceTreatmentRelations

export const CompanySurfaceTreatmentWithRelationsSchema: z.ZodType<CompanySurfaceTreatmentWithRelations> = CompanySurfaceTreatmentSchema.merge(z.object({
  companySettings: z.lazy(() => CompanySettingsWithRelationsSchema),
}))

// COMPANY SURFACE TREATMENT OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type CompanySurfaceTreatmentOptionalDefaultsRelations = {
  companySettings: CompanySettingsOptionalDefaultsWithRelations;
};

export type CompanySurfaceTreatmentOptionalDefaultsWithRelations = z.infer<typeof CompanySurfaceTreatmentOptionalDefaultsSchema> & CompanySurfaceTreatmentOptionalDefaultsRelations

export const CompanySurfaceTreatmentOptionalDefaultsWithRelationsSchema: z.ZodType<CompanySurfaceTreatmentOptionalDefaultsWithRelations> = CompanySurfaceTreatmentOptionalDefaultsSchema.merge(z.object({
  companySettings: z.lazy(() => CompanySettingsOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// PERMISSION SCHEMA
/////////////////////////////////////////

export const PermissionSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  description: z.string(),
  defaultValue: z.boolean(),
})

export type Permission = z.infer<typeof PermissionSchema>

// PERMISSION OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const PermissionOptionalDefaultsSchema = PermissionSchema.merge(z.object({
  id: z.string().uuid().optional(),
  description: z.string().optional(),
  defaultValue: z.boolean().optional(),
}))

export type PermissionOptionalDefaults = z.infer<typeof PermissionOptionalDefaultsSchema>

// PERMISSION RELATION SCHEMA
//------------------------------------------------------

export type PermissionRelations = {
  companies: CompanyPermissionWithRelations[];
};

export type PermissionWithRelations = z.infer<typeof PermissionSchema> & PermissionRelations

export const PermissionWithRelationsSchema: z.ZodType<PermissionWithRelations> = PermissionSchema.merge(z.object({
  companies: z.lazy(() => CompanyPermissionWithRelationsSchema).array(),
}))

// PERMISSION OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type PermissionOptionalDefaultsRelations = {
  companies: CompanyPermissionOptionalDefaultsWithRelations[];
};

export type PermissionOptionalDefaultsWithRelations = z.infer<typeof PermissionOptionalDefaultsSchema> & PermissionOptionalDefaultsRelations

export const PermissionOptionalDefaultsWithRelationsSchema: z.ZodType<PermissionOptionalDefaultsWithRelations> = PermissionOptionalDefaultsSchema.merge(z.object({
  companies: z.lazy(() => CompanyPermissionOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// COMPANY PERMISSION SCHEMA
/////////////////////////////////////////

export const CompanyPermissionSchema = z.object({
  value: z.boolean(),
  companyId: z.string(),
  permissionId: z.string(),
})

export type CompanyPermission = z.infer<typeof CompanyPermissionSchema>

// COMPANY PERMISSION OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const CompanyPermissionOptionalDefaultsSchema = CompanyPermissionSchema.merge(z.object({
  value: z.boolean().optional(),
}))

export type CompanyPermissionOptionalDefaults = z.infer<typeof CompanyPermissionOptionalDefaultsSchema>

// COMPANY PERMISSION RELATION SCHEMA
//------------------------------------------------------

export type CompanyPermissionRelations = {
  company: CompanyWithRelations;
  permission: PermissionWithRelations;
};

export type CompanyPermissionWithRelations = z.infer<typeof CompanyPermissionSchema> & CompanyPermissionRelations

export const CompanyPermissionWithRelationsSchema: z.ZodType<CompanyPermissionWithRelations> = CompanyPermissionSchema.merge(z.object({
  company: z.lazy(() => CompanyWithRelationsSchema),
  permission: z.lazy(() => PermissionWithRelationsSchema),
}))

// COMPANY PERMISSION OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type CompanyPermissionOptionalDefaultsRelations = {
  company: CompanyOptionalDefaultsWithRelations;
  permission: PermissionOptionalDefaultsWithRelations;
};

export type CompanyPermissionOptionalDefaultsWithRelations = z.infer<typeof CompanyPermissionOptionalDefaultsSchema> & CompanyPermissionOptionalDefaultsRelations

export const CompanyPermissionOptionalDefaultsWithRelationsSchema: z.ZodType<CompanyPermissionOptionalDefaultsWithRelations> = CompanyPermissionOptionalDefaultsSchema.merge(z.object({
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema),
  permission: z.lazy(() => PermissionOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// USER SCHEMA
/////////////////////////////////////////

export const UserSchema = z.object({
  role: RoleSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  // omitted: lastLoginAt: z.coerce.date().nullable(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  // omitted: password: z.string(),
  isDisabled: z.boolean(),
  companyId: z.string().nullable(),
  userSettingsId: z.string(),
})

export type User = z.infer<typeof UserSchema>

// USER OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const UserOptionalDefaultsSchema = UserSchema.merge(z.object({
  role: RoleSchema.optional(),
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  isDisabled: z.boolean().optional(),
}))

export type UserOptionalDefaults = z.infer<typeof UserOptionalDefaultsSchema>

// USER RELATION SCHEMA
//------------------------------------------------------

export type UserRelations = {
  company?: CompanyWithRelations | null;
  userSettings: UserSettingsWithRelations;
  quotes: QuoteWithRelations[];
  quoteRequests: QuoteRequestWithRelations[];
  resetPasswordTokens: ResetPasswordTokenWithRelations[];
  quoteRequestsOwner: QuoteRequestWithRelations[];
  oAuthAccounts: OAuthAccountWithRelations[];
  predictionFeedbacks: PredictionFeedbackWithRelations[];
  similarPartFeedbacks: SimilarPartFeedbackWithRelations[];
  mcpAuthorizationCodes: McpAuthorizationCodeWithRelations[];
  searches: SearchWithRelations[];
};

export type UserWithRelations = z.infer<typeof UserSchema> & UserRelations

export const UserWithRelationsSchema: z.ZodType<UserWithRelations> = UserSchema.merge(z.object({
  company: z.lazy(() => CompanyWithRelationsSchema).nullable(),
  userSettings: z.lazy(() => UserSettingsWithRelationsSchema),
  quotes: z.lazy(() => QuoteWithRelationsSchema).array(),
  quoteRequests: z.lazy(() => QuoteRequestWithRelationsSchema).array(),
  resetPasswordTokens: z.lazy(() => ResetPasswordTokenWithRelationsSchema).array(),
  quoteRequestsOwner: z.lazy(() => QuoteRequestWithRelationsSchema).array(),
  oAuthAccounts: z.lazy(() => OAuthAccountWithRelationsSchema).array(),
  predictionFeedbacks: z.lazy(() => PredictionFeedbackWithRelationsSchema).array(),
  similarPartFeedbacks: z.lazy(() => SimilarPartFeedbackWithRelationsSchema).array(),
  mcpAuthorizationCodes: z.lazy(() => McpAuthorizationCodeWithRelationsSchema).array(),
  searches: z.lazy(() => SearchWithRelationsSchema).array(),
}))

// USER OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type UserOptionalDefaultsRelations = {
  company?: CompanyOptionalDefaultsWithRelations | null;
  userSettings: UserSettingsOptionalDefaultsWithRelations;
  quotes: QuoteOptionalDefaultsWithRelations[];
  quoteRequests: QuoteRequestOptionalDefaultsWithRelations[];
  resetPasswordTokens: ResetPasswordTokenOptionalDefaultsWithRelations[];
  quoteRequestsOwner: QuoteRequestOptionalDefaultsWithRelations[];
  oAuthAccounts: OAuthAccountOptionalDefaultsWithRelations[];
  predictionFeedbacks: PredictionFeedbackOptionalDefaultsWithRelations[];
  similarPartFeedbacks: SimilarPartFeedbackOptionalDefaultsWithRelations[];
  mcpAuthorizationCodes: McpAuthorizationCodeOptionalDefaultsWithRelations[];
  searches: SearchOptionalDefaultsWithRelations[];
};

export type UserOptionalDefaultsWithRelations = z.infer<typeof UserOptionalDefaultsSchema> & UserOptionalDefaultsRelations

export const UserOptionalDefaultsWithRelationsSchema: z.ZodType<UserOptionalDefaultsWithRelations> = UserOptionalDefaultsSchema.merge(z.object({
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema).nullable(),
  userSettings: z.lazy(() => UserSettingsOptionalDefaultsWithRelationsSchema),
  quotes: z.lazy(() => QuoteOptionalDefaultsWithRelationsSchema).array(),
  quoteRequests: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema).array(),
  resetPasswordTokens: z.lazy(() => ResetPasswordTokenOptionalDefaultsWithRelationsSchema).array(),
  quoteRequestsOwner: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema).array(),
  oAuthAccounts: z.lazy(() => OAuthAccountOptionalDefaultsWithRelationsSchema).array(),
  predictionFeedbacks: z.lazy(() => PredictionFeedbackOptionalDefaultsWithRelationsSchema).array(),
  similarPartFeedbacks: z.lazy(() => SimilarPartFeedbackOptionalDefaultsWithRelationsSchema).array(),
  mcpAuthorizationCodes: z.lazy(() => McpAuthorizationCodeOptionalDefaultsWithRelationsSchema).array(),
  searches: z.lazy(() => SearchOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// USER SETTINGS SCHEMA
/////////////////////////////////////////

export const UserSettingsSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  quoteFollowUpEnabled: z.boolean(),
  outlookConnectionEnabled: z.boolean(),
})

export type UserSettings = z.infer<typeof UserSettingsSchema>

// USER SETTINGS OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const UserSettingsOptionalDefaultsSchema = UserSettingsSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  quoteFollowUpEnabled: z.boolean().optional(),
  outlookConnectionEnabled: z.boolean().optional(),
}))

export type UserSettingsOptionalDefaults = z.infer<typeof UserSettingsOptionalDefaultsSchema>

// USER SETTINGS RELATION SCHEMA
//------------------------------------------------------

export type UserSettingsRelations = {
  user?: UserWithRelations | null;
  quoteRequestNotificationsDelays: QuoteRequestNotificationsDelayWithRelations[];
};

export type UserSettingsWithRelations = z.infer<typeof UserSettingsSchema> & UserSettingsRelations

export const UserSettingsWithRelationsSchema: z.ZodType<UserSettingsWithRelations> = UserSettingsSchema.merge(z.object({
  user: z.lazy(() => UserWithRelationsSchema).nullable(),
  quoteRequestNotificationsDelays: z.lazy(() => QuoteRequestNotificationsDelayWithRelationsSchema).array(),
}))

// USER SETTINGS OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type UserSettingsOptionalDefaultsRelations = {
  user?: UserOptionalDefaultsWithRelations | null;
  quoteRequestNotificationsDelays: QuoteRequestNotificationsDelayOptionalDefaultsWithRelations[];
};

export type UserSettingsOptionalDefaultsWithRelations = z.infer<typeof UserSettingsOptionalDefaultsSchema> & UserSettingsOptionalDefaultsRelations

export const UserSettingsOptionalDefaultsWithRelationsSchema: z.ZodType<UserSettingsOptionalDefaultsWithRelations> = UserSettingsOptionalDefaultsSchema.merge(z.object({
  user: z.lazy(() => UserOptionalDefaultsWithRelationsSchema).nullable(),
  quoteRequestNotificationsDelays: z.lazy(() => QuoteRequestNotificationsDelayOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// CLIENT SCHEMA
/////////////////////////////////////////

export const ClientSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  name: z.string(),
  emailDomain: z.string().nullable(),
  siret: z.string().nullable(),
  erpCode: z.string().nullable(),
  comment: z.string().nullable(),
  companyId: z.string(),
})

export type Client = z.infer<typeof ClientSchema>

// CLIENT OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const ClientOptionalDefaultsSchema = ClientSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type ClientOptionalDefaults = z.infer<typeof ClientOptionalDefaultsSchema>

// CLIENT RELATION SCHEMA
//------------------------------------------------------

export type ClientRelations = {
  company: CompanyWithRelations;
  contacts: ContactWithRelations[];
  addresses: AddressWithRelations[];
  quoteRequests: QuoteRequestWithRelations[];
};

export type ClientWithRelations = z.infer<typeof ClientSchema> & ClientRelations

export const ClientWithRelationsSchema: z.ZodType<ClientWithRelations> = ClientSchema.merge(z.object({
  company: z.lazy(() => CompanyWithRelationsSchema),
  contacts: z.lazy(() => ContactWithRelationsSchema).array(),
  addresses: z.lazy(() => AddressWithRelationsSchema).array(),
  quoteRequests: z.lazy(() => QuoteRequestWithRelationsSchema).array(),
}))

// CLIENT OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type ClientOptionalDefaultsRelations = {
  company: CompanyOptionalDefaultsWithRelations;
  contacts: ContactOptionalDefaultsWithRelations[];
  addresses: AddressOptionalDefaultsWithRelations[];
  quoteRequests: QuoteRequestOptionalDefaultsWithRelations[];
};

export type ClientOptionalDefaultsWithRelations = z.infer<typeof ClientOptionalDefaultsSchema> & ClientOptionalDefaultsRelations

export const ClientOptionalDefaultsWithRelationsSchema: z.ZodType<ClientOptionalDefaultsWithRelations> = ClientOptionalDefaultsSchema.merge(z.object({
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema),
  contacts: z.lazy(() => ContactOptionalDefaultsWithRelationsSchema).array(),
  addresses: z.lazy(() => AddressOptionalDefaultsWithRelationsSchema).array(),
  quoteRequests: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// CONTACT SCHEMA
/////////////////////////////////////////

export const ContactSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phone: z.string(),
  clientId: z.string().nullable(),
})

export type Contact = z.infer<typeof ContactSchema>

// CONTACT OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const ContactOptionalDefaultsSchema = ContactSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type ContactOptionalDefaults = z.infer<typeof ContactOptionalDefaultsSchema>

// CONTACT RELATION SCHEMA
//------------------------------------------------------

export type ContactRelations = {
  client?: ClientWithRelations | null;
  quoteRequests: QuoteRequestWithRelations[];
};

export type ContactWithRelations = z.infer<typeof ContactSchema> & ContactRelations

export const ContactWithRelationsSchema: z.ZodType<ContactWithRelations> = ContactSchema.merge(z.object({
  client: z.lazy(() => ClientWithRelationsSchema).nullable(),
  quoteRequests: z.lazy(() => QuoteRequestWithRelationsSchema).array(),
}))

// CONTACT OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type ContactOptionalDefaultsRelations = {
  client?: ClientOptionalDefaultsWithRelations | null;
  quoteRequests: QuoteRequestOptionalDefaultsWithRelations[];
};

export type ContactOptionalDefaultsWithRelations = z.infer<typeof ContactOptionalDefaultsSchema> & ContactOptionalDefaultsRelations

export const ContactOptionalDefaultsWithRelationsSchema: z.ZodType<ContactOptionalDefaultsWithRelations> = ContactOptionalDefaultsSchema.merge(z.object({
  client: z.lazy(() => ClientOptionalDefaultsWithRelationsSchema).nullable(),
  quoteRequests: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// ADDRESS SCHEMA
/////////////////////////////////////////

export const AddressSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  street: z.string(),
  zipCode: z.string(),
  city: z.string(),
  country: z.string(),
  clientId: z.string().nullable(),
})

export type Address = z.infer<typeof AddressSchema>

// ADDRESS OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const AddressOptionalDefaultsSchema = AddressSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  country: z.string().optional(),
}))

export type AddressOptionalDefaults = z.infer<typeof AddressOptionalDefaultsSchema>

// ADDRESS RELATION SCHEMA
//------------------------------------------------------

export type AddressRelations = {
  client?: ClientWithRelations | null;
  company: CompanyWithRelations[];
  QuoteRequestsShippingAddress: QuoteRequestWithRelations[];
  QuoteRequestsBillingAddress: QuoteRequestWithRelations[];
};

export type AddressWithRelations = z.infer<typeof AddressSchema> & AddressRelations

export const AddressWithRelationsSchema: z.ZodType<AddressWithRelations> = AddressSchema.merge(z.object({
  client: z.lazy(() => ClientWithRelationsSchema).nullable(),
  company: z.lazy(() => CompanyWithRelationsSchema).array(),
  QuoteRequestsShippingAddress: z.lazy(() => QuoteRequestWithRelationsSchema).array(),
  QuoteRequestsBillingAddress: z.lazy(() => QuoteRequestWithRelationsSchema).array(),
}))

// ADDRESS OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type AddressOptionalDefaultsRelations = {
  client?: ClientOptionalDefaultsWithRelations | null;
  company: CompanyOptionalDefaultsWithRelations[];
  QuoteRequestsShippingAddress: QuoteRequestOptionalDefaultsWithRelations[];
  QuoteRequestsBillingAddress: QuoteRequestOptionalDefaultsWithRelations[];
};

export type AddressOptionalDefaultsWithRelations = z.infer<typeof AddressOptionalDefaultsSchema> & AddressOptionalDefaultsRelations

export const AddressOptionalDefaultsWithRelationsSchema: z.ZodType<AddressOptionalDefaultsWithRelations> = AddressOptionalDefaultsSchema.merge(z.object({
  client: z.lazy(() => ClientOptionalDefaultsWithRelationsSchema).nullable(),
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema).array(),
  QuoteRequestsShippingAddress: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema).array(),
  QuoteRequestsBillingAddress: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// QUOTE REQUEST SCHEMA
/////////////////////////////////////////

export const QuoteRequestSchema = z.object({
  status: QuoteRequestStatusSchema,
  orderType: OrderTypeSchema.nullable(),
  shippingPriority: ShippingPrioritySchema.nullable(),
  priority: PrioritySchema.nullable(),
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  mailId: z.string().nullable(),
  version: z.number().int(),
  reference: z.string().nullable(),
  clientReference: z.string().nullable(),
  isArchived: z.boolean(),
  targetPrice: z.number().int().nullable(),
  expirationDate: z.coerce.date().nullable(),
  discountRatio: z.number().nullable(),
  salesMarginRatio: z.number().nullable(),
  nCompaniesRequested: z.number().int().nullable(),
  foreignCompaniesRequested: z.boolean().nullable(),
  alreadyManufacturedParts: z.boolean().nullable(),
  salesAdministrationTime: z.number().nullable(),
  salesAdministrationHourlyRate: z.number().int().nullable(),
  salesAdministrationMarginRatio: z.number().nullable(),
  certificationNeeded: z.string().nullable(),
  skippedFollowUp: z.boolean(),
  certificateCost: z.number().int().nullable(),
  quoteSentAt: z.coerce.date().nullable(),
  dueDate: z.coerce.date().nullable(),
  isFavorite: z.boolean(),
  comment: z.string().nullable(),
  clientNote: z.string().nullable(),
  isImported: z.boolean(),
  internalId: z.string().nullable(),
  createdById: z.string().nullable(),
  shippingAddressId: z.string().nullable(),
  billingAddressId: z.string().nullable(),
  companyId: z.string(),
  clientId: z.string().nullable(),
  contactId: z.string().nullable(),
  ownerId: z.string().nullable(),
})

export type QuoteRequest = z.infer<typeof QuoteRequestSchema>

// QUOTE REQUEST OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const QuoteRequestOptionalDefaultsSchema = QuoteRequestSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  version: z.number().int().optional(),
  isArchived: z.boolean().optional(),
  skippedFollowUp: z.boolean().optional(),
  isFavorite: z.boolean().optional(),
  isImported: z.boolean().optional(),
}))

export type QuoteRequestOptionalDefaults = z.infer<typeof QuoteRequestOptionalDefaultsSchema>

// QUOTE REQUEST RELATION SCHEMA
//------------------------------------------------------

export type QuoteRequestRelations = {
  createdBy?: UserWithRelations | null;
  shippingAddress?: AddressWithRelations | null;
  billingAddress?: AddressWithRelations | null;
  company: CompanyWithRelations;
  client?: ClientWithRelations | null;
  contact?: ContactWithRelations | null;
  owner?: UserWithRelations | null;
  productLines: ProductLineWithRelations[];
  quotes: QuoteWithRelations[];
  quoteRequestLines: QuoteRequestLineWithRelations[];
  layouts: LayoutWithRelations[];
  processSteps: ProcessStepWithRelations[];
  batches: BatchWithRelations[];
  jobs: JobWithRelations[];
  optimizations: OptimizationWithRelations[];
};

export type QuoteRequestWithRelations = z.infer<typeof QuoteRequestSchema> & QuoteRequestRelations

export const QuoteRequestWithRelationsSchema: z.ZodType<QuoteRequestWithRelations> = QuoteRequestSchema.merge(z.object({
  createdBy: z.lazy(() => UserWithRelationsSchema).nullable(),
  shippingAddress: z.lazy(() => AddressWithRelationsSchema).nullable(),
  billingAddress: z.lazy(() => AddressWithRelationsSchema).nullable(),
  company: z.lazy(() => CompanyWithRelationsSchema),
  client: z.lazy(() => ClientWithRelationsSchema).nullable(),
  contact: z.lazy(() => ContactWithRelationsSchema).nullable(),
  owner: z.lazy(() => UserWithRelationsSchema).nullable(),
  productLines: z.lazy(() => ProductLineWithRelationsSchema).array(),
  quotes: z.lazy(() => QuoteWithRelationsSchema).array(),
  quoteRequestLines: z.lazy(() => QuoteRequestLineWithRelationsSchema).array(),
  layouts: z.lazy(() => LayoutWithRelationsSchema).array(),
  processSteps: z.lazy(() => ProcessStepWithRelationsSchema).array(),
  batches: z.lazy(() => BatchWithRelationsSchema).array(),
  jobs: z.lazy(() => JobWithRelationsSchema).array(),
  optimizations: z.lazy(() => OptimizationWithRelationsSchema).array(),
}))

// QUOTE REQUEST OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type QuoteRequestOptionalDefaultsRelations = {
  createdBy?: UserOptionalDefaultsWithRelations | null;
  shippingAddress?: AddressOptionalDefaultsWithRelations | null;
  billingAddress?: AddressOptionalDefaultsWithRelations | null;
  company: CompanyOptionalDefaultsWithRelations;
  client?: ClientOptionalDefaultsWithRelations | null;
  contact?: ContactOptionalDefaultsWithRelations | null;
  owner?: UserOptionalDefaultsWithRelations | null;
  productLines: ProductLineOptionalDefaultsWithRelations[];
  quotes: QuoteOptionalDefaultsWithRelations[];
  quoteRequestLines: QuoteRequestLineOptionalDefaultsWithRelations[];
  layouts: LayoutOptionalDefaultsWithRelations[];
  processSteps: ProcessStepOptionalDefaultsWithRelations[];
  batches: BatchOptionalDefaultsWithRelations[];
  jobs: JobOptionalDefaultsWithRelations[];
  optimizations: OptimizationOptionalDefaultsWithRelations[];
};

export type QuoteRequestOptionalDefaultsWithRelations = z.infer<typeof QuoteRequestOptionalDefaultsSchema> & QuoteRequestOptionalDefaultsRelations

export const QuoteRequestOptionalDefaultsWithRelationsSchema: z.ZodType<QuoteRequestOptionalDefaultsWithRelations> = QuoteRequestOptionalDefaultsSchema.merge(z.object({
  createdBy: z.lazy(() => UserOptionalDefaultsWithRelationsSchema).nullable(),
  shippingAddress: z.lazy(() => AddressOptionalDefaultsWithRelationsSchema).nullable(),
  billingAddress: z.lazy(() => AddressOptionalDefaultsWithRelationsSchema).nullable(),
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema),
  client: z.lazy(() => ClientOptionalDefaultsWithRelationsSchema).nullable(),
  contact: z.lazy(() => ContactOptionalDefaultsWithRelationsSchema).nullable(),
  owner: z.lazy(() => UserOptionalDefaultsWithRelationsSchema).nullable(),
  productLines: z.lazy(() => ProductLineOptionalDefaultsWithRelationsSchema).array(),
  quotes: z.lazy(() => QuoteOptionalDefaultsWithRelationsSchema).array(),
  quoteRequestLines: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).array(),
  layouts: z.lazy(() => LayoutOptionalDefaultsWithRelationsSchema).array(),
  processSteps: z.lazy(() => ProcessStepOptionalDefaultsWithRelationsSchema).array(),
  batches: z.lazy(() => BatchOptionalDefaultsWithRelationsSchema).array(),
  jobs: z.lazy(() => JobOptionalDefaultsWithRelationsSchema).array(),
  optimizations: z.lazy(() => OptimizationOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// QUOTE REQUEST LINE SCHEMA
/////////////////////////////////////////

export const QuoteRequestLineSchema = z.object({
  materialGrade: MaterialGradeSchema.nullable(),
  status: QuoteRequestLineStatusSchema,
  predictionStatus: JobStatusSchema.nullable(),
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  quotedAt: z.coerce.date().nullable(),
  shippingDelay: z.string().nullable(),
  index: z.number().int(),
  quantity: z.number().int(),
  materialName: z.string({description: 'Free-text material label override entered by the user, falls back to materialGrade when empty, ERP exports typically want the resolved display name rather than this raw override' }),
  comment: z.string().nullable(),
  internalComment: z.string().nullable(),
  designOfficeTime: z.number().nullable(),
  designOfficeHourlyRate: z.number().int().nullable(),
  designOfficeMarginRatio: z.number().nullable(),
  reworkRatio: z.number().nullable(),
  productsMarginRatio: z.number().nullable(),
  materialMarginRatio: z.number().nullable(),
  addedValueMarginRatio: z.number().nullable(),
  declineReason: z.string().nullable(),
  isReliable: z.boolean(),
  internalId: z.string().nullable(),
  usedInModel: z.boolean(),
  partId: z.string(),
  quoteRequestId: z.string(),
  copiedFromId: z.string().nullable(),
  batchId: z.string().nullable(),
  assemblyParentId: z.string({description: 'Id of the parent QuoteRequestLine when this line is a child part of an assembly, null for standalone lines and assembly roots' }).nullable(),
  layoutId: z.string().nullable(),
})

export type QuoteRequestLine = z.infer<typeof QuoteRequestLineSchema>

// QUOTE REQUEST LINE OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const QuoteRequestLineOptionalDefaultsSchema = QuoteRequestLineSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  index: z.number().int().optional(),
  materialName: z.string({description: 'Free-text material label override entered by the user, falls back to materialGrade when empty, ERP exports typically want the resolved display name rather than this raw override' }).optional(),
  isReliable: z.boolean().optional(),
  usedInModel: z.boolean().optional(),
}))

export type QuoteRequestLineOptionalDefaults = z.infer<typeof QuoteRequestLineOptionalDefaultsSchema>

// QUOTE REQUEST LINE RELATION SCHEMA
//------------------------------------------------------

export type QuoteRequestLineRelations = {
  part: PartWithRelations;
  quoteRequest: QuoteRequestWithRelations;
  copiedFrom?: QuoteRequestLineWithRelations | null;
  batch?: BatchWithRelations | null;
  assemblyParent?: QuoteRequestLineWithRelations | null;
  layout?: LayoutWithRelations | null;
  cluster?: ClusterWithRelations | null;
  referenceFor?: BatchWithRelations | null;
  productLines: ProductLineWithRelations[];
  processSteps: ProcessStepWithRelations[];
  templateFor: QuoteRequestLineWithRelations[];
  predictions: PredictionWithRelations[];
  targetForClusters: ClusterWithRelations[];
  jobs: JobWithRelations[];
  optimizations: OptimizationWithRelations[];
  customInputs: CustomInputWithRelations[];
  assemblyChildren: QuoteRequestLineWithRelations[];
};

export type QuoteRequestLineWithRelations = z.infer<typeof QuoteRequestLineSchema> & QuoteRequestLineRelations

export const QuoteRequestLineWithRelationsSchema: z.ZodType<QuoteRequestLineWithRelations> = QuoteRequestLineSchema.merge(z.object({
  part: z.lazy(() => PartWithRelationsSchema),
  quoteRequest: z.lazy(() => QuoteRequestWithRelationsSchema),
  copiedFrom: z.lazy(() => QuoteRequestLineWithRelationsSchema).nullable(),
  batch: z.lazy(() => BatchWithRelationsSchema).nullable(),
  assemblyParent: z.lazy(() => QuoteRequestLineWithRelationsSchema).nullable(),
  layout: z.lazy(() => LayoutWithRelationsSchema).nullable(),
  cluster: z.lazy(() => ClusterWithRelationsSchema).nullable(),
  referenceFor: z.lazy(() => BatchWithRelationsSchema).nullable(),
  productLines: z.lazy(() => ProductLineWithRelationsSchema).array(),
  processSteps: z.lazy(() => ProcessStepWithRelationsSchema).array(),
  templateFor: z.lazy(() => QuoteRequestLineWithRelationsSchema).array(),
  predictions: z.lazy(() => PredictionWithRelationsSchema).array(),
  targetForClusters: z.lazy(() => ClusterWithRelationsSchema).array(),
  jobs: z.lazy(() => JobWithRelationsSchema).array(),
  optimizations: z.lazy(() => OptimizationWithRelationsSchema).array(),
  customInputs: z.lazy(() => CustomInputWithRelationsSchema).array(),
  assemblyChildren: z.lazy(() => QuoteRequestLineWithRelationsSchema).array(),
}))

// QUOTE REQUEST LINE OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type QuoteRequestLineOptionalDefaultsRelations = {
  part: PartOptionalDefaultsWithRelations;
  quoteRequest: QuoteRequestOptionalDefaultsWithRelations;
  copiedFrom?: QuoteRequestLineOptionalDefaultsWithRelations | null;
  batch?: BatchOptionalDefaultsWithRelations | null;
  assemblyParent?: QuoteRequestLineOptionalDefaultsWithRelations | null;
  layout?: LayoutOptionalDefaultsWithRelations | null;
  cluster?: ClusterOptionalDefaultsWithRelations | null;
  referenceFor?: BatchOptionalDefaultsWithRelations | null;
  productLines: ProductLineOptionalDefaultsWithRelations[];
  processSteps: ProcessStepOptionalDefaultsWithRelations[];
  templateFor: QuoteRequestLineOptionalDefaultsWithRelations[];
  predictions: PredictionOptionalDefaultsWithRelations[];
  targetForClusters: ClusterOptionalDefaultsWithRelations[];
  jobs: JobOptionalDefaultsWithRelations[];
  optimizations: OptimizationOptionalDefaultsWithRelations[];
  customInputs: CustomInputOptionalDefaultsWithRelations[];
  assemblyChildren: QuoteRequestLineOptionalDefaultsWithRelations[];
};

export type QuoteRequestLineOptionalDefaultsWithRelations = z.infer<typeof QuoteRequestLineOptionalDefaultsSchema> & QuoteRequestLineOptionalDefaultsRelations

export const QuoteRequestLineOptionalDefaultsWithRelationsSchema: z.ZodType<QuoteRequestLineOptionalDefaultsWithRelations> = QuoteRequestLineOptionalDefaultsSchema.merge(z.object({
  part: z.lazy(() => PartOptionalDefaultsWithRelationsSchema),
  quoteRequest: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema),
  copiedFrom: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).nullable(),
  batch: z.lazy(() => BatchOptionalDefaultsWithRelationsSchema).nullable(),
  assemblyParent: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).nullable(),
  layout: z.lazy(() => LayoutOptionalDefaultsWithRelationsSchema).nullable(),
  cluster: z.lazy(() => ClusterOptionalDefaultsWithRelationsSchema).nullable(),
  referenceFor: z.lazy(() => BatchOptionalDefaultsWithRelationsSchema).nullable(),
  productLines: z.lazy(() => ProductLineOptionalDefaultsWithRelationsSchema).array(),
  processSteps: z.lazy(() => ProcessStepOptionalDefaultsWithRelationsSchema).array(),
  templateFor: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).array(),
  predictions: z.lazy(() => PredictionOptionalDefaultsWithRelationsSchema).array(),
  targetForClusters: z.lazy(() => ClusterOptionalDefaultsWithRelationsSchema).array(),
  jobs: z.lazy(() => JobOptionalDefaultsWithRelationsSchema).array(),
  optimizations: z.lazy(() => OptimizationOptionalDefaultsWithRelationsSchema).array(),
  customInputs: z.lazy(() => CustomInputOptionalDefaultsWithRelationsSchema).array(),
  assemblyChildren: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// BATCH SCHEMA
/////////////////////////////////////////

export const BatchSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  partId: z.string(),
  quoteRequestId: z.string(),
  referenceLineId: z.string({description: 'Id of the QuoteRequestLine of this batch the optimizations are computed on, falls back to the oldest line of the batch when null' }).nullable(),
})

export type Batch = z.infer<typeof BatchSchema>

// BATCH OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const BatchOptionalDefaultsSchema = BatchSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type BatchOptionalDefaults = z.infer<typeof BatchOptionalDefaultsSchema>

// BATCH RELATION SCHEMA
//------------------------------------------------------

export type BatchRelations = {
  part: PartWithRelations;
  quoteRequest: QuoteRequestWithRelations;
  referenceLine?: QuoteRequestLineWithRelations | null;
  quoteRequestLines: QuoteRequestLineWithRelations[];
};

export type BatchWithRelations = z.infer<typeof BatchSchema> & BatchRelations

export const BatchWithRelationsSchema: z.ZodType<BatchWithRelations> = BatchSchema.merge(z.object({
  part: z.lazy(() => PartWithRelationsSchema),
  quoteRequest: z.lazy(() => QuoteRequestWithRelationsSchema),
  referenceLine: z.lazy(() => QuoteRequestLineWithRelationsSchema).nullable(),
  quoteRequestLines: z.lazy(() => QuoteRequestLineWithRelationsSchema).array(),
}))

// BATCH OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type BatchOptionalDefaultsRelations = {
  part: PartOptionalDefaultsWithRelations;
  quoteRequest: QuoteRequestOptionalDefaultsWithRelations;
  referenceLine?: QuoteRequestLineOptionalDefaultsWithRelations | null;
  quoteRequestLines: QuoteRequestLineOptionalDefaultsWithRelations[];
};

export type BatchOptionalDefaultsWithRelations = z.infer<typeof BatchOptionalDefaultsSchema> & BatchOptionalDefaultsRelations

export const BatchOptionalDefaultsWithRelationsSchema: z.ZodType<BatchOptionalDefaultsWithRelations> = BatchOptionalDefaultsSchema.merge(z.object({
  part: z.lazy(() => PartOptionalDefaultsWithRelationsSchema),
  quoteRequest: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema),
  referenceLine: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).nullable(),
  quoteRequestLines: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// QUOTE SCHEMA
/////////////////////////////////////////

export const QuoteSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  version: z.string(),
  marginRatio: z.number(),
  discountRatio: z.number(),
  salesMarginRatio: z.number().nullable(),
  deliveryTime: z.number(),
  manHourlyRate: z.number().int(),
  expirationDate: z.coerce.date().nullable(),
  vat: z.number().int(),
  priceHt: z.number().int(),
  pdfFileUrl: z.string(),
  createdById: z.string(),
  quoteRequestId: z.string(),
  companyId: z.string(),
})

export type Quote = z.infer<typeof QuoteSchema>

// QUOTE OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const QuoteOptionalDefaultsSchema = QuoteSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  marginRatio: z.number().optional(),
  discountRatio: z.number().optional(),
}))

export type QuoteOptionalDefaults = z.infer<typeof QuoteOptionalDefaultsSchema>

// QUOTE RELATION SCHEMA
//------------------------------------------------------

export type QuoteRelations = {
  createdBy: UserWithRelations;
  quoteRequest: QuoteRequestWithRelations;
  company: CompanyWithRelations;
};

export type QuoteWithRelations = z.infer<typeof QuoteSchema> & QuoteRelations

export const QuoteWithRelationsSchema: z.ZodType<QuoteWithRelations> = QuoteSchema.merge(z.object({
  createdBy: z.lazy(() => UserWithRelationsSchema),
  quoteRequest: z.lazy(() => QuoteRequestWithRelationsSchema),
  company: z.lazy(() => CompanyWithRelationsSchema),
}))

// QUOTE OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type QuoteOptionalDefaultsRelations = {
  createdBy: UserOptionalDefaultsWithRelations;
  quoteRequest: QuoteRequestOptionalDefaultsWithRelations;
  company: CompanyOptionalDefaultsWithRelations;
};

export type QuoteOptionalDefaultsWithRelations = z.infer<typeof QuoteOptionalDefaultsSchema> & QuoteOptionalDefaultsRelations

export const QuoteOptionalDefaultsWithRelationsSchema: z.ZodType<QuoteOptionalDefaultsWithRelations> = QuoteOptionalDefaultsSchema.merge(z.object({
  createdBy: z.lazy(() => UserOptionalDefaultsWithRelationsSchema),
  quoteRequest: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema),
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// PRODUCT SCHEMA
/////////////////////////////////////////

export const ProductSchema = z.object({
  type: ProductTypeSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  name: z.string(),
  price: z.number().int(),
  fixedPrice: z.number().int().nullable(),
  companyId: z.string().nullable(),
  companySettingsId: z.string().nullable(),
})

export type Product = z.infer<typeof ProductSchema>

// PRODUCT OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const ProductOptionalDefaultsSchema = ProductSchema.merge(z.object({
  type: ProductTypeSchema.optional(),
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type ProductOptionalDefaults = z.infer<typeof ProductOptionalDefaultsSchema>

// PRODUCT RELATION SCHEMA
//------------------------------------------------------

export type ProductRelations = {
  company?: CompanyWithRelations | null;
  companySettings?: CompanySettingsWithRelations | null;
  productLines: ProductLineWithRelations[];
};

export type ProductWithRelations = z.infer<typeof ProductSchema> & ProductRelations

export const ProductWithRelationsSchema: z.ZodType<ProductWithRelations> = ProductSchema.merge(z.object({
  company: z.lazy(() => CompanyWithRelationsSchema).nullable(),
  companySettings: z.lazy(() => CompanySettingsWithRelationsSchema).nullable(),
  productLines: z.lazy(() => ProductLineWithRelationsSchema).array(),
}))

// PRODUCT OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type ProductOptionalDefaultsRelations = {
  company?: CompanyOptionalDefaultsWithRelations | null;
  companySettings?: CompanySettingsOptionalDefaultsWithRelations | null;
  productLines: ProductLineOptionalDefaultsWithRelations[];
};

export type ProductOptionalDefaultsWithRelations = z.infer<typeof ProductOptionalDefaultsSchema> & ProductOptionalDefaultsRelations

export const ProductOptionalDefaultsWithRelationsSchema: z.ZodType<ProductOptionalDefaultsWithRelations> = ProductOptionalDefaultsSchema.merge(z.object({
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema).nullable(),
  companySettings: z.lazy(() => CompanySettingsOptionalDefaultsWithRelationsSchema).nullable(),
  productLines: z.lazy(() => ProductLineOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// PRODUCT LINE SCHEMA
/////////////////////////////////////////

export const ProductLineSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  isQuantityPerPart: z.boolean(),
  quantity: z.number(),
  name: z.string(),
  price: z.number().int(),
  fixedPrice: z.number().int().nullable(),
  productId: z.string(),
  quoteRequestLineId: z.string().nullable(),
  processStepId: z.string().nullable(),
  quoteRequestId: z.string().nullable(),
})

export type ProductLine = z.infer<typeof ProductLineSchema>

// PRODUCT LINE OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const ProductLineOptionalDefaultsSchema = ProductLineSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  isQuantityPerPart: z.boolean().optional(),
  name: z.string().optional(),
  price: z.number().int().optional(),
}))

export type ProductLineOptionalDefaults = z.infer<typeof ProductLineOptionalDefaultsSchema>

// PRODUCT LINE RELATION SCHEMA
//------------------------------------------------------

export type ProductLineRelations = {
  product: ProductWithRelations;
  quoteRequestLine?: QuoteRequestLineWithRelations | null;
  processStep?: ProcessStepWithRelations | null;
  quoteRequest?: QuoteRequestWithRelations | null;
};

export type ProductLineWithRelations = z.infer<typeof ProductLineSchema> & ProductLineRelations

export const ProductLineWithRelationsSchema: z.ZodType<ProductLineWithRelations> = ProductLineSchema.merge(z.object({
  product: z.lazy(() => ProductWithRelationsSchema),
  quoteRequestLine: z.lazy(() => QuoteRequestLineWithRelationsSchema).nullable(),
  processStep: z.lazy(() => ProcessStepWithRelationsSchema).nullable(),
  quoteRequest: z.lazy(() => QuoteRequestWithRelationsSchema).nullable(),
}))

// PRODUCT LINE OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type ProductLineOptionalDefaultsRelations = {
  product: ProductOptionalDefaultsWithRelations;
  quoteRequestLine?: QuoteRequestLineOptionalDefaultsWithRelations | null;
  processStep?: ProcessStepOptionalDefaultsWithRelations | null;
  quoteRequest?: QuoteRequestOptionalDefaultsWithRelations | null;
};

export type ProductLineOptionalDefaultsWithRelations = z.infer<typeof ProductLineOptionalDefaultsSchema> & ProductLineOptionalDefaultsRelations

export const ProductLineOptionalDefaultsWithRelationsSchema: z.ZodType<ProductLineOptionalDefaultsWithRelations> = ProductLineOptionalDefaultsSchema.merge(z.object({
  product: z.lazy(() => ProductOptionalDefaultsWithRelationsSchema),
  quoteRequestLine: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).nullable(),
  processStep: z.lazy(() => ProcessStepOptionalDefaultsWithRelationsSchema).nullable(),
  quoteRequest: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema).nullable(),
}))

/////////////////////////////////////////
// PART SCHEMA
/////////////////////////////////////////

export const PartSchema = z.object({
  type: PartTypeSchema.nullable(),
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  name: z.string(),
  clientReference: z.string().nullable(),
  internalReference: z.string().nullable(),
  hasEmbedding: z.boolean().nullable(),
  hasTopologicalEmbedding: z.boolean().nullable(),
  hasDrawingEmbedding: z.boolean().nullable(),
  // omitted: // omitted: featuresJson: JsonValueSchema.nullable(),
  subType: z.string().nullable(),
  heightOverride: z.number().nullable(),
  widthOverride: z.number().nullable(),
  lengthOverride: z.number().nullable(),
  tubeThicknessOverride: z.number().nullable(),
  weightOverride: z.number().nullable(),
  quantityInAssemblyOverride: z.number({description: 'Manual override for the number of instances of this part within its parent assembly, takes precedence over the CAD-analysis-derived count' }).nullable(),
  // omitted: // omitted: featuresJsonOverride: JsonValueSchema.nullable(),
  parentId: z.string().nullable(),
  rootParentId: z.string().nullable(),
  companyId: z.string(),
})

export type Part = z.infer<typeof PartSchema>

// PART OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const PartOptionalDefaultsSchema = PartSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type PartOptionalDefaults = z.infer<typeof PartOptionalDefaultsSchema>

// PART RELATION SCHEMA
//------------------------------------------------------

export type PartRelations = {
  parent?: PartWithRelations | null;
  rootParent?: PartWithRelations | null;
  company: CompanyWithRelations;
  files: FileWithRelations[];
  quoteRequestLines: QuoteRequestLineWithRelations[];
  children: PartWithRelations[];
  rootChildren: PartWithRelations[];
  batches: BatchWithRelations[];
  similarPartFeedbacksAsSource: SimilarPartFeedbackWithRelations[];
  similarPartFeedbacksAsTarget: SimilarPartFeedbackWithRelations[];
  optimizationNotifications: OptimizationNotificationWithRelations[];
};

export type PartWithRelations = Omit<z.infer<typeof PartSchema>, "featuresJson" | "featuresJsonOverride"> & {
  featuresJson?: JsonValueType | null;
  featuresJsonOverride?: JsonValueType | null;
} & PartRelations

export const PartWithRelationsSchema: z.ZodType<PartWithRelations> = PartSchema.merge(z.object({
  parent: z.lazy(() => PartWithRelationsSchema).nullable(),
  rootParent: z.lazy(() => PartWithRelationsSchema).nullable(),
  company: z.lazy(() => CompanyWithRelationsSchema),
  files: z.lazy(() => FileWithRelationsSchema).array(),
  quoteRequestLines: z.lazy(() => QuoteRequestLineWithRelationsSchema).array(),
  children: z.lazy(() => PartWithRelationsSchema).array(),
  rootChildren: z.lazy(() => PartWithRelationsSchema).array(),
  batches: z.lazy(() => BatchWithRelationsSchema).array(),
  similarPartFeedbacksAsSource: z.lazy(() => SimilarPartFeedbackWithRelationsSchema).array(),
  similarPartFeedbacksAsTarget: z.lazy(() => SimilarPartFeedbackWithRelationsSchema).array(),
  optimizationNotifications: z.lazy(() => OptimizationNotificationWithRelationsSchema).array(),
}))

// PART OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type PartOptionalDefaultsRelations = {
  parent?: PartOptionalDefaultsWithRelations | null;
  rootParent?: PartOptionalDefaultsWithRelations | null;
  company: CompanyOptionalDefaultsWithRelations;
  files: FileOptionalDefaultsWithRelations[];
  quoteRequestLines: QuoteRequestLineOptionalDefaultsWithRelations[];
  children: PartOptionalDefaultsWithRelations[];
  rootChildren: PartOptionalDefaultsWithRelations[];
  batches: BatchOptionalDefaultsWithRelations[];
  similarPartFeedbacksAsSource: SimilarPartFeedbackOptionalDefaultsWithRelations[];
  similarPartFeedbacksAsTarget: SimilarPartFeedbackOptionalDefaultsWithRelations[];
  optimizationNotifications: OptimizationNotificationOptionalDefaultsWithRelations[];
};

export type PartOptionalDefaultsWithRelations = Omit<z.infer<typeof PartOptionalDefaultsSchema>, "featuresJson" | "featuresJsonOverride"> & {
  featuresJson?: JsonValueType | null;
  featuresJsonOverride?: JsonValueType | null;
} & PartOptionalDefaultsRelations

export const PartOptionalDefaultsWithRelationsSchema: z.ZodType<PartOptionalDefaultsWithRelations> = PartOptionalDefaultsSchema.merge(z.object({
  parent: z.lazy(() => PartOptionalDefaultsWithRelationsSchema).nullable(),
  rootParent: z.lazy(() => PartOptionalDefaultsWithRelationsSchema).nullable(),
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema),
  files: z.lazy(() => FileOptionalDefaultsWithRelationsSchema).array(),
  quoteRequestLines: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).array(),
  children: z.lazy(() => PartOptionalDefaultsWithRelationsSchema).array(),
  rootChildren: z.lazy(() => PartOptionalDefaultsWithRelationsSchema).array(),
  batches: z.lazy(() => BatchOptionalDefaultsWithRelationsSchema).array(),
  similarPartFeedbacksAsSource: z.lazy(() => SimilarPartFeedbackOptionalDefaultsWithRelationsSchema).array(),
  similarPartFeedbacksAsTarget: z.lazy(() => SimilarPartFeedbackOptionalDefaultsWithRelationsSchema).array(),
  optimizationNotifications: z.lazy(() => OptimizationNotificationOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// FILE SCHEMA
/////////////////////////////////////////

export const FileSchema = z.object({
  type: FileTypeSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  url: z.string(),
  name: z.string(),
  hash: z.string().nullable(),
  size: z.number().int().nullable(),
  companyId: z.string().nullable(),
  partId: z.string().nullable(),
})

export type File = z.infer<typeof FileSchema>

// FILE OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const FileOptionalDefaultsSchema = FileSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type FileOptionalDefaults = z.infer<typeof FileOptionalDefaultsSchema>

// FILE RELATION SCHEMA
//------------------------------------------------------

export type FileRelations = {
  company?: CompanyWithRelations | null;
  part?: PartWithRelations | null;
  partAnalysis?: PartAnalysisWithRelations | null;
};

export type FileWithRelations = z.infer<typeof FileSchema> & FileRelations

export const FileWithRelationsSchema: z.ZodType<FileWithRelations> = FileSchema.merge(z.object({
  company: z.lazy(() => CompanyWithRelationsSchema).nullable(),
  part: z.lazy(() => PartWithRelationsSchema).nullable(),
  partAnalysis: z.lazy(() => PartAnalysisWithRelationsSchema).nullable(),
}))

// FILE OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type FileOptionalDefaultsRelations = {
  company?: CompanyOptionalDefaultsWithRelations | null;
  part?: PartOptionalDefaultsWithRelations | null;
  partAnalysis?: PartAnalysisOptionalDefaultsWithRelations | null;
};

export type FileOptionalDefaultsWithRelations = z.infer<typeof FileOptionalDefaultsSchema> & FileOptionalDefaultsRelations

export const FileOptionalDefaultsWithRelationsSchema: z.ZodType<FileOptionalDefaultsWithRelations> = FileOptionalDefaultsSchema.merge(z.object({
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema).nullable(),
  part: z.lazy(() => PartOptionalDefaultsWithRelationsSchema).nullable(),
  partAnalysis: z.lazy(() => PartAnalysisOptionalDefaultsWithRelationsSchema).nullable(),
}))

/////////////////////////////////////////
// PART ANALYSIS SCHEMA
/////////////////////////////////////////

export const PartAnalysisSchema = z.object({
  source: PartAnalysisSourceSchema,
  materialGrade: MaterialGradeSchema.nullable(),
  gltfStatus: JobStatusSchema,
  previewStatus: JobStatusSchema,
  pdfPreviewStatus: JobStatusSchema,
  embeddingStatus: JobStatusSchema,
  featuresStatus: JobStatusSchema,
  graphStatus: JobStatusSchema,
  analyzeStatus: JobStatusSchema,
  analyze2DStatus: JobStatusSchema,
  topologicalEmbeddingStatus: JobStatusSchema,
  drawingEmbeddingStatus: JobStatusSchema,
  drawingAnalyticExtractionStatus: JobStatusSchema,
  drawingLLMExtractionStatus: JobStatusSchema,
  flatPatternStatus: JobStatusSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  urlGltf: z.string().nullable(),
  urlPng: z.string().nullable(),
  urlPdfAnnotated: z.string().nullable(),
  urlPdfPreview: z.string().nullable(),
  materialName: z.string().nullable(),
  surfaceTreatments: z.string().array(),
  height: z.number().nullable(),
  width: z.number().nullable(),
  length: z.number().nullable(),
  tubeThickness: z.number().nullable(),
  volume: z.number().nullable(),
  weight: z.number().nullable(),
  area: z.number().nullable(),
  boundingBoxX: z.number().nullable(),
  boundingBoxY: z.number().nullable(),
  boundingBoxZ: z.number().nullable(),
  boundingBoxVolume: z.number().nullable(),
  boundingBoxArea: z.number().nullable(),
  tolerance: z.string().nullable(),
  // omitted: // omitted: partJson: JsonValueSchema.nullable(),
  /**
   * True if partJson was rebuilt from legacy flat columns instead of a real PYCAD analysis
   */
  isPartJsonReconstructed: z.boolean(),
  // omitted: graphUrl: z.string().nullable(),
  graphVersion: z.string().nullable(),
  // omitted: // omitted: analyze2DJson: JsonValueSchema.nullable(),
  /**
   * Flat (unfolded) outline of a sheet metal part as a nesting-core ItemType JSON (outer contour and holes as line/arc segments, in mm), sent by pycad (STEP unfolding) or pyplan (DXF) and used as nesting input
   */
  // omitted: // omitted: flatPattern: JsonValueSchema.nullable(),
  quantityInAssembly: z.number({description: 'Number of instances of this part detected within its parent assembly by CAD analysis, can be manually overridden on the Part' }).nullable(),
  fileId: z.string(),
})

export type PartAnalysis = z.infer<typeof PartAnalysisSchema>

// PART ANALYSIS OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const PartAnalysisOptionalDefaultsSchema = PartAnalysisSchema.merge(z.object({
  gltfStatus: JobStatusSchema.optional(),
  previewStatus: JobStatusSchema.optional(),
  pdfPreviewStatus: JobStatusSchema.optional(),
  embeddingStatus: JobStatusSchema.optional(),
  featuresStatus: JobStatusSchema.optional(),
  graphStatus: JobStatusSchema.optional(),
  analyzeStatus: JobStatusSchema.optional(),
  analyze2DStatus: JobStatusSchema.optional(),
  topologicalEmbeddingStatus: JobStatusSchema.optional(),
  drawingEmbeddingStatus: JobStatusSchema.optional(),
  drawingAnalyticExtractionStatus: JobStatusSchema.optional(),
  drawingLLMExtractionStatus: JobStatusSchema.optional(),
  flatPatternStatus: JobStatusSchema.optional(),
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  surfaceTreatments: z.string().array().optional(),
  /**
   * True if partJson was rebuilt from legacy flat columns instead of a real PYCAD analysis
   */
  isPartJsonReconstructed: z.boolean().optional(),
}))

export type PartAnalysisOptionalDefaults = z.infer<typeof PartAnalysisOptionalDefaultsSchema>

// PART ANALYSIS RELATION SCHEMA
//------------------------------------------------------

export type PartAnalysisRelations = {
  file: FileWithRelations;
  jobs: JobWithRelations[];
};

export type PartAnalysisWithRelations = Omit<z.infer<typeof PartAnalysisSchema>, "partJson" | "analyze2DJson" | "flatPattern"> & {
  partJson?: JsonValueType | null;
  analyze2DJson?: JsonValueType | null;
  flatPattern?: JsonValueType | null;
} & PartAnalysisRelations

export const PartAnalysisWithRelationsSchema: z.ZodType<PartAnalysisWithRelations> = PartAnalysisSchema.merge(z.object({
  file: z.lazy(() => FileWithRelationsSchema),
  jobs: z.lazy(() => JobWithRelationsSchema).array(),
}))

// PART ANALYSIS OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type PartAnalysisOptionalDefaultsRelations = {
  file: FileOptionalDefaultsWithRelations;
  jobs: JobOptionalDefaultsWithRelations[];
};

export type PartAnalysisOptionalDefaultsWithRelations = Omit<z.infer<typeof PartAnalysisOptionalDefaultsSchema>, "partJson" | "analyze2DJson" | "flatPattern"> & {
  partJson?: JsonValueType | null;
  analyze2DJson?: JsonValueType | null;
  flatPattern?: JsonValueType | null;
} & PartAnalysisOptionalDefaultsRelations

export const PartAnalysisOptionalDefaultsWithRelationsSchema: z.ZodType<PartAnalysisOptionalDefaultsWithRelations> = PartAnalysisOptionalDefaultsSchema.merge(z.object({
  file: z.lazy(() => FileOptionalDefaultsWithRelationsSchema),
  jobs: z.lazy(() => JobOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// PROCESS STEP SCHEMA
/////////////////////////////////////////

export const ProcessStepSchema = z.object({
  mode: ProcessStepModeSchema,
  industrialProcess: IndustrialProcessSchema,
  sourceCycleTime: SourceCycleTimeSchema.nullable(),
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  index: z.number().int(),
  description: z.string().nullable(),
  margin: z.number(),
  toolingCost: z.number().int().nullable(),
  otherMachineTime: z.number({description: 'Machine cycle time per part, in minutes, multiplied by quantity to get the process step\'s total machine time' }).nullable(),
  modelCycleTime: z.number().nullable(),
  abacusCycleTime: z.number().nullable(),
  machinePreparationTime: z.number({description: 'Machine setup or changeover time, in minutes, applied once for the whole series regardless of quantity' }).nullable(),
  machineHourlyPrice: z.number().int().nullable(),
  manTime: z.number({description: 'Operator time per part, in minutes, applied once for the whole series instead of per part on ASSEMBLING steps when isFixedCostPerSeries is true' }).nullable(),
  manHourlyPrice: z.number().int(),
  alerts: JsonValueSchema.nullable(),
  isFixedCostPerSeries: z.boolean().nullable(),
  fixedCost: z.number({description: 'Fixed cost per part, in cents, multiplied by quantity when computing the process step\'s total cost' }).nullable(),
  isFixedCostManuallyEdited: z.boolean(),
  fixedCostPerSeries: z.number({description: 'Fixed cost for the whole series, in cents, applied once regardless of quantity' }).nullable(),
  materialLoadTimeMinutes: z.number().nullable(),
  partLoadTimeMinutes: z.number().nullable(),
  materialUnloadingTime: z.number().nullable(),
  partsToPackQuantity: z.number().int().nullable(),
  minimumOrderAmount: z.number().nullable(),
  productsMarginRatio: z.number().nullable(),
  packingHourlyPrice: z.number().int().nullable(),
  partsToControlRatio: z.number().nullable(),
  isMaterialLayoutPerPart: z.boolean().nullable(),
  isOutsourced: z.boolean().nullable(),
  cycleTimeCost: z.number().nullable(),
  machinePreparationTimeCost: z.number().nullable(),
  materialLayoutId: z.string().nullable(),
  predictionId: z.string().nullable(),
  companyMachineId: z.string().nullable(),
  quoteRequestLineId: z.string().nullable(),
  quoteRequestId: z.string().nullable(),
})

export type ProcessStep = z.infer<typeof ProcessStepSchema>

// PROCESS STEP OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const ProcessStepOptionalDefaultsSchema = ProcessStepSchema.merge(z.object({
  mode: ProcessStepModeSchema.optional(),
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  index: z.number().int().optional(),
  margin: z.number().optional(),
  manHourlyPrice: z.number().int().optional(),
  isFixedCostManuallyEdited: z.boolean().optional(),
}))

export type ProcessStepOptionalDefaults = z.infer<typeof ProcessStepOptionalDefaultsSchema>

// PROCESS STEP RELATION SCHEMA
//------------------------------------------------------

export type ProcessStepRelations = {
  materialLayout?: MaterialLayoutWithRelations | null;
  prediction?: PredictionWithRelations | null;
  companyMachine?: CompanyMachineWithRelations | null;
  quoteRequestLine?: QuoteRequestLineWithRelations | null;
  quoteRequest?: QuoteRequestWithRelations | null;
  productLines: ProductLineWithRelations[];
  excludedFromClusters: ClusterWithRelations[];
};

export type ProcessStepWithRelations = Omit<z.infer<typeof ProcessStepSchema>, "alerts"> & {
  alerts?: JsonValueType | null;
} & ProcessStepRelations

export const ProcessStepWithRelationsSchema: z.ZodType<ProcessStepWithRelations> = ProcessStepSchema.merge(z.object({
  materialLayout: z.lazy(() => MaterialLayoutWithRelationsSchema).nullable(),
  prediction: z.lazy(() => PredictionWithRelationsSchema).nullable(),
  companyMachine: z.lazy(() => CompanyMachineWithRelationsSchema).nullable(),
  quoteRequestLine: z.lazy(() => QuoteRequestLineWithRelationsSchema).nullable(),
  quoteRequest: z.lazy(() => QuoteRequestWithRelationsSchema).nullable(),
  productLines: z.lazy(() => ProductLineWithRelationsSchema).array(),
  excludedFromClusters: z.lazy(() => ClusterWithRelationsSchema).array(),
}))

// PROCESS STEP OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type ProcessStepOptionalDefaultsRelations = {
  materialLayout?: MaterialLayoutOptionalDefaultsWithRelations | null;
  prediction?: PredictionOptionalDefaultsWithRelations | null;
  companyMachine?: CompanyMachineOptionalDefaultsWithRelations | null;
  quoteRequestLine?: QuoteRequestLineOptionalDefaultsWithRelations | null;
  quoteRequest?: QuoteRequestOptionalDefaultsWithRelations | null;
  productLines: ProductLineOptionalDefaultsWithRelations[];
  excludedFromClusters: ClusterOptionalDefaultsWithRelations[];
};

export type ProcessStepOptionalDefaultsWithRelations = Omit<z.infer<typeof ProcessStepOptionalDefaultsSchema>, "alerts"> & {
  alerts?: JsonValueType | null;
} & ProcessStepOptionalDefaultsRelations

export const ProcessStepOptionalDefaultsWithRelationsSchema: z.ZodType<ProcessStepOptionalDefaultsWithRelations> = ProcessStepOptionalDefaultsSchema.merge(z.object({
  materialLayout: z.lazy(() => MaterialLayoutOptionalDefaultsWithRelationsSchema).nullable(),
  prediction: z.lazy(() => PredictionOptionalDefaultsWithRelationsSchema).nullable(),
  companyMachine: z.lazy(() => CompanyMachineOptionalDefaultsWithRelationsSchema).nullable(),
  quoteRequestLine: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).nullable(),
  quoteRequest: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema).nullable(),
  productLines: z.lazy(() => ProductLineOptionalDefaultsWithRelationsSchema).array(),
  excludedFromClusters: z.lazy(() => ClusterOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// DEFAULT PROCESS STEP SCHEMA
/////////////////////////////////////////

export const DefaultProcessStepSchema = z.object({
  industrialProcess: IndustrialProcessSchema,
  partLevels: PartLevelSchema.array(),
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  index: z.number().int(),
  description: z.string().nullable(),
  preparationTimeFormula: z.string().nullable(),
  cycleTimeFormula: z.string().nullable(),
  machineHourlyPrice: z.number().int().nullable(),
  companySettingsId: z.string(),
})

export type DefaultProcessStep = z.infer<typeof DefaultProcessStepSchema>

// DEFAULT PROCESS STEP OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const DefaultProcessStepOptionalDefaultsSchema = DefaultProcessStepSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  index: z.number().int().optional(),
}))

export type DefaultProcessStepOptionalDefaults = z.infer<typeof DefaultProcessStepOptionalDefaultsSchema>

// DEFAULT PROCESS STEP RELATION SCHEMA
//------------------------------------------------------

export type DefaultProcessStepRelations = {
  CompanySettings: CompanySettingsWithRelations;
};

export type DefaultProcessStepWithRelations = z.infer<typeof DefaultProcessStepSchema> & DefaultProcessStepRelations

export const DefaultProcessStepWithRelationsSchema: z.ZodType<DefaultProcessStepWithRelations> = DefaultProcessStepSchema.merge(z.object({
  CompanySettings: z.lazy(() => CompanySettingsWithRelationsSchema),
}))

// DEFAULT PROCESS STEP OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type DefaultProcessStepOptionalDefaultsRelations = {
  CompanySettings: CompanySettingsOptionalDefaultsWithRelations;
};

export type DefaultProcessStepOptionalDefaultsWithRelations = z.infer<typeof DefaultProcessStepOptionalDefaultsSchema> & DefaultProcessStepOptionalDefaultsRelations

export const DefaultProcessStepOptionalDefaultsWithRelationsSchema: z.ZodType<DefaultProcessStepOptionalDefaultsWithRelations> = DefaultProcessStepOptionalDefaultsSchema.merge(z.object({
  CompanySettings: z.lazy(() => CompanySettingsOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// MACHINE SCHEMA
/////////////////////////////////////////

export const MachineSchema = z.object({
  industrialProcess: IndustrialProcessSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  internalId: z.number().int().nullable(),
  brand: z.string().nullable(),
  name: z.string(),
  companyId: z.string().nullable(),
})

export type Machine = z.infer<typeof MachineSchema>

// MACHINE OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const MachineOptionalDefaultsSchema = MachineSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type MachineOptionalDefaults = z.infer<typeof MachineOptionalDefaultsSchema>

// MACHINE RELATION SCHEMA
//------------------------------------------------------

export type MachineRelations = {
  company?: CompanyWithRelations | null;
  companyMachines: CompanyMachineWithRelations[];
};

export type MachineWithRelations = z.infer<typeof MachineSchema> & MachineRelations

export const MachineWithRelationsSchema: z.ZodType<MachineWithRelations> = MachineSchema.merge(z.object({
  company: z.lazy(() => CompanyWithRelationsSchema).nullable(),
  companyMachines: z.lazy(() => CompanyMachineWithRelationsSchema).array(),
}))

// MACHINE OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type MachineOptionalDefaultsRelations = {
  company?: CompanyOptionalDefaultsWithRelations | null;
  companyMachines: CompanyMachineOptionalDefaultsWithRelations[];
};

export type MachineOptionalDefaultsWithRelations = z.infer<typeof MachineOptionalDefaultsSchema> & MachineOptionalDefaultsRelations

export const MachineOptionalDefaultsWithRelationsSchema: z.ZodType<MachineOptionalDefaultsWithRelations> = MachineOptionalDefaultsSchema.merge(z.object({
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema).nullable(),
  companyMachines: z.lazy(() => CompanyMachineOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// COMPANY MACHINE SCHEMA
/////////////////////////////////////////

export const CompanyMachineSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullable(),
  machineHourlyPrice: z.number().int(),
  cycleTimeFormula: z.string().nullable(),
  preparationTimeFormula: z.string().nullable(),
  materialLoadTimeMinutes: z.number().nullable(),
  marginRatio: z.number().nullable(),
  modelProcessStepDescription: z.string().nullable(),
  processStepDescriptionOverride: z.string().nullable(),
  canBeOptimized: z.boolean(),
  companyId: z.string(),
  machineId: z.string(),
})

export type CompanyMachine = z.infer<typeof CompanyMachineSchema>

// COMPANY MACHINE OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const CompanyMachineOptionalDefaultsSchema = CompanyMachineSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  canBeOptimized: z.boolean().optional(),
}))

export type CompanyMachineOptionalDefaults = z.infer<typeof CompanyMachineOptionalDefaultsSchema>

// COMPANY MACHINE RELATION SCHEMA
//------------------------------------------------------

export type CompanyMachineRelations = {
  company: CompanyWithRelations;
  machine: MachineWithRelations;
  processSteps: ProcessStepWithRelations[];
  machineTimesOptimizationMetadata: MachineTimesOptimizationMetadataWithRelations[];
};

export type CompanyMachineWithRelations = z.infer<typeof CompanyMachineSchema> & CompanyMachineRelations

export const CompanyMachineWithRelationsSchema: z.ZodType<CompanyMachineWithRelations> = CompanyMachineSchema.merge(z.object({
  company: z.lazy(() => CompanyWithRelationsSchema),
  machine: z.lazy(() => MachineWithRelationsSchema),
  processSteps: z.lazy(() => ProcessStepWithRelationsSchema).array(),
  machineTimesOptimizationMetadata: z.lazy(() => MachineTimesOptimizationMetadataWithRelationsSchema).array(),
}))

// COMPANY MACHINE OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type CompanyMachineOptionalDefaultsRelations = {
  company: CompanyOptionalDefaultsWithRelations;
  machine: MachineOptionalDefaultsWithRelations;
  processSteps: ProcessStepOptionalDefaultsWithRelations[];
  machineTimesOptimizationMetadata: MachineTimesOptimizationMetadataOptionalDefaultsWithRelations[];
};

export type CompanyMachineOptionalDefaultsWithRelations = z.infer<typeof CompanyMachineOptionalDefaultsSchema> & CompanyMachineOptionalDefaultsRelations

export const CompanyMachineOptionalDefaultsWithRelationsSchema: z.ZodType<CompanyMachineOptionalDefaultsWithRelations> = CompanyMachineOptionalDefaultsSchema.merge(z.object({
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema),
  machine: z.lazy(() => MachineOptionalDefaultsWithRelationsSchema),
  processSteps: z.lazy(() => ProcessStepOptionalDefaultsWithRelationsSchema).array(),
  machineTimesOptimizationMetadata: z.lazy(() => MachineTimesOptimizationMetadataOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// MATERIAL SCHEMA
/////////////////////////////////////////

export const MaterialSchema = z.object({
  type: MaterialTypeSchema,
  materialGrade: MaterialGradeSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  internalId: z.number().int().nullable(),
  name: z.string(),
  subType: z.string().nullable(),
  height: z.number(),
  width: z.number(),
  length: z.number(),
  tubeThickness: z.number().nullable(),
  density: z.number().nullable(),
  price: z.number().int(),
  companyId: z.string().nullable(),
})

export type Material = z.infer<typeof MaterialSchema>

// MATERIAL OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const MaterialOptionalDefaultsSchema = MaterialSchema.merge(z.object({
  materialGrade: MaterialGradeSchema.optional(),
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  price: z.number().int().optional(),
}))

export type MaterialOptionalDefaults = z.infer<typeof MaterialOptionalDefaultsSchema>

// MATERIAL RELATION SCHEMA
//------------------------------------------------------

export type MaterialRelations = {
  company?: CompanyWithRelations | null;
  materialLayouts: MaterialLayoutWithRelations[];
};

export type MaterialWithRelations = z.infer<typeof MaterialSchema> & MaterialRelations

export const MaterialWithRelationsSchema: z.ZodType<MaterialWithRelations> = MaterialSchema.merge(z.object({
  company: z.lazy(() => CompanyWithRelationsSchema).nullable(),
  materialLayouts: z.lazy(() => MaterialLayoutWithRelationsSchema).array(),
}))

// MATERIAL OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type MaterialOptionalDefaultsRelations = {
  company?: CompanyOptionalDefaultsWithRelations | null;
  materialLayouts: MaterialLayoutOptionalDefaultsWithRelations[];
};

export type MaterialOptionalDefaultsWithRelations = z.infer<typeof MaterialOptionalDefaultsSchema> & MaterialOptionalDefaultsRelations

export const MaterialOptionalDefaultsWithRelationsSchema: z.ZodType<MaterialOptionalDefaultsWithRelations> = MaterialOptionalDefaultsSchema.merge(z.object({
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema).nullable(),
  materialLayouts: z.lazy(() => MaterialLayoutOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// MATERIAL VOLUMETRIC SCHEMA
/////////////////////////////////////////

export const MaterialVolumetricSchema = z.object({
  materialGrade: MaterialGradeSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  name: z.string(),
  volumetricPrice: z.number().int(),
  companyId: z.string(),
})

export type MaterialVolumetric = z.infer<typeof MaterialVolumetricSchema>

// MATERIAL VOLUMETRIC OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const MaterialVolumetricOptionalDefaultsSchema = MaterialVolumetricSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  name: z.string().optional(),
}))

export type MaterialVolumetricOptionalDefaults = z.infer<typeof MaterialVolumetricOptionalDefaultsSchema>

// MATERIAL VOLUMETRIC RELATION SCHEMA
//------------------------------------------------------

export type MaterialVolumetricRelations = {
  company: CompanyWithRelations;
  materialLayouts: MaterialLayoutWithRelations[];
};

export type MaterialVolumetricWithRelations = z.infer<typeof MaterialVolumetricSchema> & MaterialVolumetricRelations

export const MaterialVolumetricWithRelationsSchema: z.ZodType<MaterialVolumetricWithRelations> = MaterialVolumetricSchema.merge(z.object({
  company: z.lazy(() => CompanyWithRelationsSchema),
  materialLayouts: z.lazy(() => MaterialLayoutWithRelationsSchema).array(),
}))

// MATERIAL VOLUMETRIC OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type MaterialVolumetricOptionalDefaultsRelations = {
  company: CompanyOptionalDefaultsWithRelations;
  materialLayouts: MaterialLayoutOptionalDefaultsWithRelations[];
};

export type MaterialVolumetricOptionalDefaultsWithRelations = z.infer<typeof MaterialVolumetricOptionalDefaultsSchema> & MaterialVolumetricOptionalDefaultsRelations

export const MaterialVolumetricOptionalDefaultsWithRelationsSchema: z.ZodType<MaterialVolumetricOptionalDefaultsWithRelations> = MaterialVolumetricOptionalDefaultsSchema.merge(z.object({
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema),
  materialLayouts: z.lazy(() => MaterialLayoutOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// MATERIAL LAYOUT SCHEMA
/////////////////////////////////////////

export const MaterialLayoutSchema = z.object({
  pricingMode: PricingModeSchema,
  type: PartTypeSchema.nullable(),
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  length: z.number({description: 'Length of the raw material stock, bar or tube length or sheet length, in mm' }),
  tubeThickness: z.number().nullable(),
  width: z.number({description: 'Width of the raw material stock, bar or tube diameter or width or sheet width, in mm' }),
  height: z.number({description: 'Height of the raw material stock, in mm, for sheet materials this is the sheet thickness rather than a physical height' }),
  price: z.number().nullable(),
  volume: z.number().nullable(),
  volumetricPrice: z.number().nullable(),
  density: z.number(),
  quantity: z.number({description: 'Number of raw material stock units, sheets or bars, needed to produce the ordered quantity' }),
  maxPartsPerLayout: z.number().int().nullable(),
  materialId: z.string().nullable(),
  materialVolumetricId: z.string().nullable(),
  layoutId: z.string().nullable(),
})

export type MaterialLayout = z.infer<typeof MaterialLayoutSchema>

// MATERIAL LAYOUT OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const MaterialLayoutOptionalDefaultsSchema = MaterialLayoutSchema.merge(z.object({
  pricingMode: PricingModeSchema.optional(),
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type MaterialLayoutOptionalDefaults = z.infer<typeof MaterialLayoutOptionalDefaultsSchema>

// MATERIAL LAYOUT RELATION SCHEMA
//------------------------------------------------------

export type MaterialLayoutRelations = {
  material?: MaterialWithRelations | null;
  materialVolumetric?: MaterialVolumetricWithRelations | null;
  layout?: LayoutWithRelations | null;
  processStep: ProcessStepWithRelations[];
};

export type MaterialLayoutWithRelations = z.infer<typeof MaterialLayoutSchema> & MaterialLayoutRelations

export const MaterialLayoutWithRelationsSchema: z.ZodType<MaterialLayoutWithRelations> = MaterialLayoutSchema.merge(z.object({
  material: z.lazy(() => MaterialWithRelationsSchema).nullable(),
  materialVolumetric: z.lazy(() => MaterialVolumetricWithRelationsSchema).nullable(),
  layout: z.lazy(() => LayoutWithRelationsSchema).nullable(),
  processStep: z.lazy(() => ProcessStepWithRelationsSchema).array(),
}))

// MATERIAL LAYOUT OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type MaterialLayoutOptionalDefaultsRelations = {
  material?: MaterialOptionalDefaultsWithRelations | null;
  materialVolumetric?: MaterialVolumetricOptionalDefaultsWithRelations | null;
  layout?: LayoutOptionalDefaultsWithRelations | null;
  processStep: ProcessStepOptionalDefaultsWithRelations[];
};

export type MaterialLayoutOptionalDefaultsWithRelations = z.infer<typeof MaterialLayoutOptionalDefaultsSchema> & MaterialLayoutOptionalDefaultsRelations

export const MaterialLayoutOptionalDefaultsWithRelationsSchema: z.ZodType<MaterialLayoutOptionalDefaultsWithRelations> = MaterialLayoutOptionalDefaultsSchema.merge(z.object({
  material: z.lazy(() => MaterialOptionalDefaultsWithRelationsSchema).nullable(),
  materialVolumetric: z.lazy(() => MaterialVolumetricOptionalDefaultsWithRelationsSchema).nullable(),
  layout: z.lazy(() => LayoutOptionalDefaultsWithRelationsSchema).nullable(),
  processStep: z.lazy(() => ProcessStepOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// LAYOUT SCHEMA
/////////////////////////////////////////

export const LayoutSchema = z.object({
  status: LayoutStatusSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  useNesting: z.boolean().nullable(),
  cutWidth: z.number().nullable(),
  skeletonWidth: z.number().nullable(),
  scrapRatio: z.number().nullable(),
  scrapMaterialBillingRate: z.number(),
  newScrapMaterialBillingRate: z.number(),
  margin: z.number(),
  materialsLogisticsCostsRatio: z.number(),
  hasAutoScrapRatio: z.boolean(),
  quoteRequestId: z.string(),
  /**
   * Nesting run whose result is reflected in the material layout; null while no run has been applied
   */
  appliedNestingRunId: z.string().nullable(),
})

export type Layout = z.infer<typeof LayoutSchema>

// LAYOUT OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const LayoutOptionalDefaultsSchema = LayoutSchema.merge(z.object({
  status: LayoutStatusSchema.optional(),
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  scrapMaterialBillingRate: z.number().optional(),
  newScrapMaterialBillingRate: z.number().optional(),
  margin: z.number().optional(),
  materialsLogisticsCostsRatio: z.number().optional(),
  hasAutoScrapRatio: z.boolean().optional(),
}))

export type LayoutOptionalDefaults = z.infer<typeof LayoutOptionalDefaultsSchema>

// LAYOUT RELATION SCHEMA
//------------------------------------------------------

export type LayoutRelations = {
  quoteRequest: QuoteRequestWithRelations;
  appliedNestingRun?: NestingRunWithRelations | null;
  materialLayout?: MaterialLayoutWithRelations | null;
  quoteRequestLine?: QuoteRequestLineWithRelations | null;
  sheetNestingOptimizationMetadata?: SheetNestingOptimizationMetadataWithRelations | null;
  nestingRuns: NestingRunWithRelations[];
};

export type LayoutWithRelations = z.infer<typeof LayoutSchema> & LayoutRelations

export const LayoutWithRelationsSchema: z.ZodType<LayoutWithRelations> = LayoutSchema.merge(z.object({
  quoteRequest: z.lazy(() => QuoteRequestWithRelationsSchema),
  appliedNestingRun: z.lazy(() => NestingRunWithRelationsSchema).nullable(),
  materialLayout: z.lazy(() => MaterialLayoutWithRelationsSchema).nullable(),
  quoteRequestLine: z.lazy(() => QuoteRequestLineWithRelationsSchema).nullable(),
  sheetNestingOptimizationMetadata: z.lazy(() => SheetNestingOptimizationMetadataWithRelationsSchema).nullable(),
  nestingRuns: z.lazy(() => NestingRunWithRelationsSchema).array(),
}))

// LAYOUT OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type LayoutOptionalDefaultsRelations = {
  quoteRequest: QuoteRequestOptionalDefaultsWithRelations;
  appliedNestingRun?: NestingRunOptionalDefaultsWithRelations | null;
  materialLayout?: MaterialLayoutOptionalDefaultsWithRelations | null;
  quoteRequestLine?: QuoteRequestLineOptionalDefaultsWithRelations | null;
  sheetNestingOptimizationMetadata?: SheetNestingOptimizationMetadataOptionalDefaultsWithRelations | null;
  nestingRuns: NestingRunOptionalDefaultsWithRelations[];
};

export type LayoutOptionalDefaultsWithRelations = z.infer<typeof LayoutOptionalDefaultsSchema> & LayoutOptionalDefaultsRelations

export const LayoutOptionalDefaultsWithRelationsSchema: z.ZodType<LayoutOptionalDefaultsWithRelations> = LayoutOptionalDefaultsSchema.merge(z.object({
  quoteRequest: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema),
  appliedNestingRun: z.lazy(() => NestingRunOptionalDefaultsWithRelationsSchema).nullable(),
  materialLayout: z.lazy(() => MaterialLayoutOptionalDefaultsWithRelationsSchema).nullable(),
  quoteRequestLine: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).nullable(),
  sheetNestingOptimizationMetadata: z.lazy(() => SheetNestingOptimizationMetadataOptionalDefaultsWithRelationsSchema).nullable(),
  nestingRuns: z.lazy(() => NestingRunOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// NESTING RUN SCHEMA
/////////////////////////////////////////

/**
 * One true-shape nesting of the sheet metal lines of a layout on its sheet format; nesting again creates a new run.
 */
export const NestingRunSchema = z.object({
  status: JobStatusSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  /**
   * True when the true-shape engine failed and the bounding-box estimate was used instead
   */
  isFallback: z.boolean(),
  sheetsUsed: z.number().int().nullable(),
  /**
   * Full sheets plus the used length of the last one, in mm²: the material actually consumed
   */
  consumedAreaMm2: z.number().nullable(),
  /**
   * nesting-core NestingSolution: placements per sheet and material area allocated to each quote line
   */
  // omitted: // omitted: solution: JsonValueSchema.nullable(),
  /**
   * nesting-core LayoutMetadata[]: one entry per distinct sheet layout, with the S3 key of its SVG
   */
  // omitted: // omitted: layouts: JsonValueSchema.nullable(),
  /**
   * Nesting warnings, or the failure reason when status is ERROR
   */
  warnings: z.string().array(),
  /**
   * Errors catalog key of the failure when status is ERROR and its cause is known
   */
  errorCode: z.string().nullable(),
  /**
   * Id of the item the error code refers to, when it concerns a single item
   */
  errorItemId: z.string().nullable(),
  /**
   * Parts fitting on a single sheet, computed by the nesting engine when the quantity fits on one sheet
   */
  simpleNestingSheetCapacity: z.number().int().nullable(),
  layoutId: z.string(),
})

export type NestingRun = z.infer<typeof NestingRunSchema>

// NESTING RUN OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const NestingRunOptionalDefaultsSchema = NestingRunSchema.merge(z.object({
  status: JobStatusSchema.optional(),
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  /**
   * True when the true-shape engine failed and the bounding-box estimate was used instead
   */
  isFallback: z.boolean().optional(),
}))

export type NestingRunOptionalDefaults = z.infer<typeof NestingRunOptionalDefaultsSchema>

// NESTING RUN RELATION SCHEMA
//------------------------------------------------------

export type NestingRunRelations = {
  layout: LayoutWithRelations;
  appliedToLayout?: LayoutWithRelations | null;
};

export type NestingRunWithRelations = Omit<z.infer<typeof NestingRunSchema>, "solution" | "layouts"> & {
  solution?: JsonValueType | null;
  layouts?: JsonValueType | null;
} & NestingRunRelations

export const NestingRunWithRelationsSchema: z.ZodType<NestingRunWithRelations> = NestingRunSchema.merge(z.object({
  layout: z.lazy(() => LayoutWithRelationsSchema),
  appliedToLayout: z.lazy(() => LayoutWithRelationsSchema).nullable(),
}))

// NESTING RUN OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type NestingRunOptionalDefaultsRelations = {
  layout: LayoutOptionalDefaultsWithRelations;
  appliedToLayout?: LayoutOptionalDefaultsWithRelations | null;
};

export type NestingRunOptionalDefaultsWithRelations = Omit<z.infer<typeof NestingRunOptionalDefaultsSchema>, "solution" | "layouts"> & {
  solution?: JsonValueType | null;
  layouts?: JsonValueType | null;
} & NestingRunOptionalDefaultsRelations

export const NestingRunOptionalDefaultsWithRelationsSchema: z.ZodType<NestingRunOptionalDefaultsWithRelations> = NestingRunOptionalDefaultsSchema.merge(z.object({
  layout: z.lazy(() => LayoutOptionalDefaultsWithRelationsSchema),
  appliedToLayout: z.lazy(() => LayoutOptionalDefaultsWithRelationsSchema).nullable(),
}))

/////////////////////////////////////////
// OPTIMIZATION SCHEMA
/////////////////////////////////////////

export const OptimizationSchema = z.object({
  type: OptimizationTypeSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullable(),
  enabled: z.boolean(),
  quoteRequestId: z.string(),
})

export type Optimization = z.infer<typeof OptimizationSchema>

// OPTIMIZATION OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const OptimizationOptionalDefaultsSchema = OptimizationSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  enabled: z.boolean().optional(),
}))

export type OptimizationOptionalDefaults = z.infer<typeof OptimizationOptionalDefaultsSchema>

// OPTIMIZATION RELATION SCHEMA
//------------------------------------------------------

export type OptimizationRelations = {
  quoteRequest: QuoteRequestWithRelations;
  sheetNestingOptimizationMetadata?: SheetNestingOptimizationMetadataWithRelations | null;
  quoteRequestLines: QuoteRequestLineWithRelations[];
  machineTimesOptimizationMetadata?: MachineTimesOptimizationMetadataWithRelations | null;
  optimizationNotifications: OptimizationNotificationWithRelations[];
};

export type OptimizationWithRelations = z.infer<typeof OptimizationSchema> & OptimizationRelations

export const OptimizationWithRelationsSchema: z.ZodType<OptimizationWithRelations> = OptimizationSchema.merge(z.object({
  quoteRequest: z.lazy(() => QuoteRequestWithRelationsSchema),
  sheetNestingOptimizationMetadata: z.lazy(() => SheetNestingOptimizationMetadataWithRelationsSchema).nullable(),
  quoteRequestLines: z.lazy(() => QuoteRequestLineWithRelationsSchema).array(),
  machineTimesOptimizationMetadata: z.lazy(() => MachineTimesOptimizationMetadataWithRelationsSchema).nullable(),
  optimizationNotifications: z.lazy(() => OptimizationNotificationWithRelationsSchema).array(),
}))

// OPTIMIZATION OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type OptimizationOptionalDefaultsRelations = {
  quoteRequest: QuoteRequestOptionalDefaultsWithRelations;
  sheetNestingOptimizationMetadata?: SheetNestingOptimizationMetadataOptionalDefaultsWithRelations | null;
  quoteRequestLines: QuoteRequestLineOptionalDefaultsWithRelations[];
  machineTimesOptimizationMetadata?: MachineTimesOptimizationMetadataOptionalDefaultsWithRelations | null;
  optimizationNotifications: OptimizationNotificationOptionalDefaultsWithRelations[];
};

export type OptimizationOptionalDefaultsWithRelations = z.infer<typeof OptimizationOptionalDefaultsSchema> & OptimizationOptionalDefaultsRelations

export const OptimizationOptionalDefaultsWithRelationsSchema: z.ZodType<OptimizationOptionalDefaultsWithRelations> = OptimizationOptionalDefaultsSchema.merge(z.object({
  quoteRequest: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema),
  sheetNestingOptimizationMetadata: z.lazy(() => SheetNestingOptimizationMetadataOptionalDefaultsWithRelationsSchema).nullable(),
  quoteRequestLines: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).array(),
  machineTimesOptimizationMetadata: z.lazy(() => MachineTimesOptimizationMetadataOptionalDefaultsWithRelationsSchema).nullable(),
  optimizationNotifications: z.lazy(() => OptimizationNotificationOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// OPTIMIZATION NOTIFICATION SCHEMA
/////////////////////////////////////////

export const OptimizationNotificationSchema = z.object({
  type: OptimizationNotificationTypeSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  readAt: z.coerce.date().nullable(),
  partId: z.string(),
  optimizationId: z.string(),
})

export type OptimizationNotification = z.infer<typeof OptimizationNotificationSchema>

// OPTIMIZATION NOTIFICATION OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const OptimizationNotificationOptionalDefaultsSchema = OptimizationNotificationSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type OptimizationNotificationOptionalDefaults = z.infer<typeof OptimizationNotificationOptionalDefaultsSchema>

// OPTIMIZATION NOTIFICATION RELATION SCHEMA
//------------------------------------------------------

export type OptimizationNotificationRelations = {
  part: PartWithRelations;
  optimization: OptimizationWithRelations;
};

export type OptimizationNotificationWithRelations = z.infer<typeof OptimizationNotificationSchema> & OptimizationNotificationRelations

export const OptimizationNotificationWithRelationsSchema: z.ZodType<OptimizationNotificationWithRelations> = OptimizationNotificationSchema.merge(z.object({
  part: z.lazy(() => PartWithRelationsSchema),
  optimization: z.lazy(() => OptimizationWithRelationsSchema),
}))

// OPTIMIZATION NOTIFICATION OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type OptimizationNotificationOptionalDefaultsRelations = {
  part: PartOptionalDefaultsWithRelations;
  optimization: OptimizationOptionalDefaultsWithRelations;
};

export type OptimizationNotificationOptionalDefaultsWithRelations = z.infer<typeof OptimizationNotificationOptionalDefaultsSchema> & OptimizationNotificationOptionalDefaultsRelations

export const OptimizationNotificationOptionalDefaultsWithRelationsSchema: z.ZodType<OptimizationNotificationOptionalDefaultsWithRelations> = OptimizationNotificationOptionalDefaultsSchema.merge(z.object({
  part: z.lazy(() => PartOptionalDefaultsWithRelationsSchema),
  optimization: z.lazy(() => OptimizationOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// SHEET NESTING OPTIMIZATION METADATA SCHEMA
/////////////////////////////////////////

export const SheetNestingOptimizationMetadataSchema = z.object({
  materialGrade: MaterialGradeSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  height: z.number(),
  materialName: z.string(),
  optimizationId: z.string(),
  layoutId: z.string().nullable(),
})

export type SheetNestingOptimizationMetadata = z.infer<typeof SheetNestingOptimizationMetadataSchema>

// SHEET NESTING OPTIMIZATION METADATA OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const SheetNestingOptimizationMetadataOptionalDefaultsSchema = SheetNestingOptimizationMetadataSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type SheetNestingOptimizationMetadataOptionalDefaults = z.infer<typeof SheetNestingOptimizationMetadataOptionalDefaultsSchema>

// SHEET NESTING OPTIMIZATION METADATA RELATION SCHEMA
//------------------------------------------------------

export type SheetNestingOptimizationMetadataRelations = {
  optimization: OptimizationWithRelations;
  layout?: LayoutWithRelations | null;
};

export type SheetNestingOptimizationMetadataWithRelations = z.infer<typeof SheetNestingOptimizationMetadataSchema> & SheetNestingOptimizationMetadataRelations

export const SheetNestingOptimizationMetadataWithRelationsSchema: z.ZodType<SheetNestingOptimizationMetadataWithRelations> = SheetNestingOptimizationMetadataSchema.merge(z.object({
  optimization: z.lazy(() => OptimizationWithRelationsSchema),
  layout: z.lazy(() => LayoutWithRelationsSchema).nullable(),
}))

// SHEET NESTING OPTIMIZATION METADATA OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type SheetNestingOptimizationMetadataOptionalDefaultsRelations = {
  optimization: OptimizationOptionalDefaultsWithRelations;
  layout?: LayoutOptionalDefaultsWithRelations | null;
};

export type SheetNestingOptimizationMetadataOptionalDefaultsWithRelations = z.infer<typeof SheetNestingOptimizationMetadataOptionalDefaultsSchema> & SheetNestingOptimizationMetadataOptionalDefaultsRelations

export const SheetNestingOptimizationMetadataOptionalDefaultsWithRelationsSchema: z.ZodType<SheetNestingOptimizationMetadataOptionalDefaultsWithRelations> = SheetNestingOptimizationMetadataOptionalDefaultsSchema.merge(z.object({
  optimization: z.lazy(() => OptimizationOptionalDefaultsWithRelationsSchema),
  layout: z.lazy(() => LayoutOptionalDefaultsWithRelationsSchema).nullable(),
}))

/////////////////////////////////////////
// MACHINE TIMES OPTIMIZATION METADATA SCHEMA
/////////////////////////////////////////

export const MachineTimesOptimizationMetadataSchema = z.object({
  materialGrade: MaterialGradeSchema.nullable(),
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  height: z.number().nullable(),
  width: z.number().nullable(),
  length: z.number().nullable(),
  tubeThickness: z.number().nullable(),
  materialName: z.string().nullable(),
  machinePreparationTime: z.number(),
  otherMachineTime: z.number(),
  companyMachineId: z.string(),
  optimizationId: z.string(),
})

export type MachineTimesOptimizationMetadata = z.infer<typeof MachineTimesOptimizationMetadataSchema>

// MACHINE TIMES OPTIMIZATION METADATA OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const MachineTimesOptimizationMetadataOptionalDefaultsSchema = MachineTimesOptimizationMetadataSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type MachineTimesOptimizationMetadataOptionalDefaults = z.infer<typeof MachineTimesOptimizationMetadataOptionalDefaultsSchema>

// MACHINE TIMES OPTIMIZATION METADATA RELATION SCHEMA
//------------------------------------------------------

export type MachineTimesOptimizationMetadataRelations = {
  companyMachine: CompanyMachineWithRelations;
  optimization: OptimizationWithRelations;
};

export type MachineTimesOptimizationMetadataWithRelations = z.infer<typeof MachineTimesOptimizationMetadataSchema> & MachineTimesOptimizationMetadataRelations

export const MachineTimesOptimizationMetadataWithRelationsSchema: z.ZodType<MachineTimesOptimizationMetadataWithRelations> = MachineTimesOptimizationMetadataSchema.merge(z.object({
  companyMachine: z.lazy(() => CompanyMachineWithRelationsSchema),
  optimization: z.lazy(() => OptimizationWithRelationsSchema),
}))

// MACHINE TIMES OPTIMIZATION METADATA OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type MachineTimesOptimizationMetadataOptionalDefaultsRelations = {
  companyMachine: CompanyMachineOptionalDefaultsWithRelations;
  optimization: OptimizationOptionalDefaultsWithRelations;
};

export type MachineTimesOptimizationMetadataOptionalDefaultsWithRelations = z.infer<typeof MachineTimesOptimizationMetadataOptionalDefaultsSchema> & MachineTimesOptimizationMetadataOptionalDefaultsRelations

export const MachineTimesOptimizationMetadataOptionalDefaultsWithRelationsSchema: z.ZodType<MachineTimesOptimizationMetadataOptionalDefaultsWithRelations> = MachineTimesOptimizationMetadataOptionalDefaultsSchema.merge(z.object({
  companyMachine: z.lazy(() => CompanyMachineOptionalDefaultsWithRelationsSchema),
  optimization: z.lazy(() => OptimizationOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// MODEL SCHEMA
/////////////////////////////////////////

export const ModelSchema = z.object({
  type: PredictionModelTypeSchema,
  drawingExtractionMethod: DrawingExtractionMethodSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  name: z.string(),
  key: z.string(),
})

export type Model = z.infer<typeof ModelSchema>

// MODEL OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const ModelOptionalDefaultsSchema = ModelSchema.merge(z.object({
  type: PredictionModelTypeSchema.optional(),
  drawingExtractionMethod: DrawingExtractionMethodSchema.optional(),
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type ModelOptionalDefaults = z.infer<typeof ModelOptionalDefaultsSchema>

// MODEL RELATION SCHEMA
//------------------------------------------------------

export type ModelRelations = {
  companySettings: CompanySettingsWithRelations[];
};

export type ModelWithRelations = z.infer<typeof ModelSchema> & ModelRelations

export const ModelWithRelationsSchema: z.ZodType<ModelWithRelations> = ModelSchema.merge(z.object({
  companySettings: z.lazy(() => CompanySettingsWithRelationsSchema).array(),
}))

// MODEL OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type ModelOptionalDefaultsRelations = {
  companySettings: CompanySettingsOptionalDefaultsWithRelations[];
};

export type ModelOptionalDefaultsWithRelations = z.infer<typeof ModelOptionalDefaultsSchema> & ModelOptionalDefaultsRelations

export const ModelOptionalDefaultsWithRelationsSchema: z.ZodType<ModelOptionalDefaultsWithRelations> = ModelOptionalDefaultsSchema.merge(z.object({
  companySettings: z.lazy(() => CompanySettingsOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// PREDICTION SCHEMA
/////////////////////////////////////////

export const PredictionSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  modelVersion: z.string(),
  graphUrl: z.string().nullable(),
  apiRequest: JsonValueSchema,
  apiResponse: JsonValueSchema,
  inputHash: z.string().nullable(),
  quoteRequestLineId: z.string().nullable(),
})

export type Prediction = z.infer<typeof PredictionSchema>

// PREDICTION OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const PredictionOptionalDefaultsSchema = PredictionSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type PredictionOptionalDefaults = z.infer<typeof PredictionOptionalDefaultsSchema>

// PREDICTION RELATION SCHEMA
//------------------------------------------------------

export type PredictionRelations = {
  quoteRequestLine?: QuoteRequestLineWithRelations | null;
  processSteps: ProcessStepWithRelations[];
  userFeedback: PredictionFeedbackWithRelations[];
};

export type PredictionWithRelations = z.infer<typeof PredictionSchema> & PredictionRelations

export const PredictionWithRelationsSchema: z.ZodType<PredictionWithRelations> = PredictionSchema.merge(z.object({
  quoteRequestLine: z.lazy(() => QuoteRequestLineWithRelationsSchema).nullable(),
  processSteps: z.lazy(() => ProcessStepWithRelationsSchema).array(),
  userFeedback: z.lazy(() => PredictionFeedbackWithRelationsSchema).array(),
}))

// PREDICTION OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type PredictionOptionalDefaultsRelations = {
  quoteRequestLine?: QuoteRequestLineOptionalDefaultsWithRelations | null;
  processSteps: ProcessStepOptionalDefaultsWithRelations[];
  userFeedback: PredictionFeedbackOptionalDefaultsWithRelations[];
};

export type PredictionOptionalDefaultsWithRelations = z.infer<typeof PredictionOptionalDefaultsSchema> & PredictionOptionalDefaultsRelations

export const PredictionOptionalDefaultsWithRelationsSchema: z.ZodType<PredictionOptionalDefaultsWithRelations> = PredictionOptionalDefaultsSchema.merge(z.object({
  quoteRequestLine: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).nullable(),
  processSteps: z.lazy(() => ProcessStepOptionalDefaultsWithRelationsSchema).array(),
  userFeedback: z.lazy(() => PredictionFeedbackOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// PREDICTION FEEDBACK SCHEMA
/////////////////////////////////////////

export const PredictionFeedbackSchema = z.object({
  causes: PredictionFeedbackCauseSchema.array(),
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  rating: z.number().int(),
  comment: z.string().nullable(),
  actualMaterialPrice: z.number().nullable(),
  actualAddedValuePrice: z.number().nullable(),
  actualTotalPrice: z.number().nullable(),
  predictionId: z.string(),
  userId: z.string(),
})

export type PredictionFeedback = z.infer<typeof PredictionFeedbackSchema>

// PREDICTION FEEDBACK OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const PredictionFeedbackOptionalDefaultsSchema = PredictionFeedbackSchema.merge(z.object({
  causes: PredictionFeedbackCauseSchema.array().optional(),
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type PredictionFeedbackOptionalDefaults = z.infer<typeof PredictionFeedbackOptionalDefaultsSchema>

// PREDICTION FEEDBACK RELATION SCHEMA
//------------------------------------------------------

export type PredictionFeedbackRelations = {
  prediction: PredictionWithRelations;
  user: UserWithRelations;
};

export type PredictionFeedbackWithRelations = z.infer<typeof PredictionFeedbackSchema> & PredictionFeedbackRelations

export const PredictionFeedbackWithRelationsSchema: z.ZodType<PredictionFeedbackWithRelations> = PredictionFeedbackSchema.merge(z.object({
  prediction: z.lazy(() => PredictionWithRelationsSchema),
  user: z.lazy(() => UserWithRelationsSchema),
}))

// PREDICTION FEEDBACK OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type PredictionFeedbackOptionalDefaultsRelations = {
  prediction: PredictionOptionalDefaultsWithRelations;
  user: UserOptionalDefaultsWithRelations;
};

export type PredictionFeedbackOptionalDefaultsWithRelations = z.infer<typeof PredictionFeedbackOptionalDefaultsSchema> & PredictionFeedbackOptionalDefaultsRelations

export const PredictionFeedbackOptionalDefaultsWithRelationsSchema: z.ZodType<PredictionFeedbackOptionalDefaultsWithRelations> = PredictionFeedbackOptionalDefaultsSchema.merge(z.object({
  prediction: z.lazy(() => PredictionOptionalDefaultsWithRelationsSchema),
  user: z.lazy(() => UserOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// SIMILAR PART FEEDBACK SCHEMA
/////////////////////////////////////////

export const SimilarPartFeedbackSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  rating: z.number().int(),
  index: z.number({description: 'Index of the similar part in the search results'}),
  userId: z.string(),
  sourcePartId: z.string(),
  targetPartId: z.string(),
})

export type SimilarPartFeedback = z.infer<typeof SimilarPartFeedbackSchema>

// SIMILAR PART FEEDBACK OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const SimilarPartFeedbackOptionalDefaultsSchema = SimilarPartFeedbackSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  index: z.number({description: 'Index of the similar part in the search results'}).optional(),
}))

export type SimilarPartFeedbackOptionalDefaults = z.infer<typeof SimilarPartFeedbackOptionalDefaultsSchema>

// SIMILAR PART FEEDBACK RELATION SCHEMA
//------------------------------------------------------

export type SimilarPartFeedbackRelations = {
  user: UserWithRelations;
  sourcePart: PartWithRelations;
  targetPart: PartWithRelations;
};

export type SimilarPartFeedbackWithRelations = z.infer<typeof SimilarPartFeedbackSchema> & SimilarPartFeedbackRelations

export const SimilarPartFeedbackWithRelationsSchema: z.ZodType<SimilarPartFeedbackWithRelations> = SimilarPartFeedbackSchema.merge(z.object({
  user: z.lazy(() => UserWithRelationsSchema),
  sourcePart: z.lazy(() => PartWithRelationsSchema),
  targetPart: z.lazy(() => PartWithRelationsSchema),
}))

// SIMILAR PART FEEDBACK OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type SimilarPartFeedbackOptionalDefaultsRelations = {
  user: UserOptionalDefaultsWithRelations;
  sourcePart: PartOptionalDefaultsWithRelations;
  targetPart: PartOptionalDefaultsWithRelations;
};

export type SimilarPartFeedbackOptionalDefaultsWithRelations = z.infer<typeof SimilarPartFeedbackOptionalDefaultsSchema> & SimilarPartFeedbackOptionalDefaultsRelations

export const SimilarPartFeedbackOptionalDefaultsWithRelationsSchema: z.ZodType<SimilarPartFeedbackOptionalDefaultsWithRelations> = SimilarPartFeedbackOptionalDefaultsSchema.merge(z.object({
  user: z.lazy(() => UserOptionalDefaultsWithRelationsSchema),
  sourcePart: z.lazy(() => PartOptionalDefaultsWithRelationsSchema),
  targetPart: z.lazy(() => PartOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// CLUSTER SCHEMA
/////////////////////////////////////////

export const ClusterSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  sourceQuoteRequestLineId: z.string(),
})

export type Cluster = z.infer<typeof ClusterSchema>

// CLUSTER OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const ClusterOptionalDefaultsSchema = ClusterSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type ClusterOptionalDefaults = z.infer<typeof ClusterOptionalDefaultsSchema>

// CLUSTER RELATION SCHEMA
//------------------------------------------------------

export type ClusterRelations = {
  sourceQuoteRequestLine: QuoteRequestLineWithRelations;
  targetQuoteRequestLines: QuoteRequestLineWithRelations[];
  excludedProcessSteps: ProcessStepWithRelations[];
};

export type ClusterWithRelations = z.infer<typeof ClusterSchema> & ClusterRelations

export const ClusterWithRelationsSchema: z.ZodType<ClusterWithRelations> = ClusterSchema.merge(z.object({
  sourceQuoteRequestLine: z.lazy(() => QuoteRequestLineWithRelationsSchema),
  targetQuoteRequestLines: z.lazy(() => QuoteRequestLineWithRelationsSchema).array(),
  excludedProcessSteps: z.lazy(() => ProcessStepWithRelationsSchema).array(),
}))

// CLUSTER OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type ClusterOptionalDefaultsRelations = {
  sourceQuoteRequestLine: QuoteRequestLineOptionalDefaultsWithRelations;
  targetQuoteRequestLines: QuoteRequestLineOptionalDefaultsWithRelations[];
  excludedProcessSteps: ProcessStepOptionalDefaultsWithRelations[];
};

export type ClusterOptionalDefaultsWithRelations = z.infer<typeof ClusterOptionalDefaultsSchema> & ClusterOptionalDefaultsRelations

export const ClusterOptionalDefaultsWithRelationsSchema: z.ZodType<ClusterOptionalDefaultsWithRelations> = ClusterOptionalDefaultsSchema.merge(z.object({
  sourceQuoteRequestLine: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema),
  targetQuoteRequestLines: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).array(),
  excludedProcessSteps: z.lazy(() => ProcessStepOptionalDefaultsWithRelationsSchema).array(),
}))

/////////////////////////////////////////
// CUSTOM INPUT SCHEMA
/////////////////////////////////////////

export const CustomInputSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  modelVersion: z.string(),
  key: z.string(),
  label: z.string(),
  value: z.string().nullable(),
  quoteRequestLineId: z.string().nullable(),
})

export type CustomInput = z.infer<typeof CustomInputSchema>

// CUSTOM INPUT OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const CustomInputOptionalDefaultsSchema = CustomInputSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type CustomInputOptionalDefaults = z.infer<typeof CustomInputOptionalDefaultsSchema>

// CUSTOM INPUT RELATION SCHEMA
//------------------------------------------------------

export type CustomInputRelations = {
  quoteRequestLine?: QuoteRequestLineWithRelations | null;
};

export type CustomInputWithRelations = z.infer<typeof CustomInputSchema> & CustomInputRelations

export const CustomInputWithRelationsSchema: z.ZodType<CustomInputWithRelations> = CustomInputSchema.merge(z.object({
  quoteRequestLine: z.lazy(() => QuoteRequestLineWithRelationsSchema).nullable(),
}))

// CUSTOM INPUT OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type CustomInputOptionalDefaultsRelations = {
  quoteRequestLine?: QuoteRequestLineOptionalDefaultsWithRelations | null;
};

export type CustomInputOptionalDefaultsWithRelations = z.infer<typeof CustomInputOptionalDefaultsSchema> & CustomInputOptionalDefaultsRelations

export const CustomInputOptionalDefaultsWithRelationsSchema: z.ZodType<CustomInputOptionalDefaultsWithRelations> = CustomInputOptionalDefaultsSchema.merge(z.object({
  quoteRequestLine: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).nullable(),
}))

/////////////////////////////////////////
// JOB SCHEMA
/////////////////////////////////////////

export const JobSchema = z.object({
  type: JobTypeSchema,
  subType: JobSubTypeSchema.nullable(),
  status: JobStatusSchema,
  errorCode: JobErrorCodeSchema.nullable(),
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  externalId: z.string().nullable(),
  // omitted: // omitted: inputPayload: JsonValueSchema.nullable(),
  outputPayload: JsonValueSchema.nullable(),
  rawErrorMessage: z.string().nullable(),
  errorMetadata: JsonValueSchema.nullable(),
  partAnalysisId: z.string().nullable(),
  quoteRequestLineId: z.string().nullable(),
  quoteRequestId: z.string().nullable(),
  companyId: z.string().nullable(),
})

export type Job = z.infer<typeof JobSchema>

// JOB OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const JobOptionalDefaultsSchema = JobSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type JobOptionalDefaults = z.infer<typeof JobOptionalDefaultsSchema>

// JOB RELATION SCHEMA
//------------------------------------------------------

export type JobRelations = {
  partAnalysis?: PartAnalysisWithRelations | null;
  quoteRequestLine?: QuoteRequestLineWithRelations | null;
  quoteRequest?: QuoteRequestWithRelations | null;
  company?: CompanyWithRelations | null;
};

export type JobWithRelations = Omit<z.infer<typeof JobSchema>, "inputPayload" | "outputPayload" | "errorMetadata"> & {
  inputPayload?: JsonValueType | null;
  outputPayload?: JsonValueType | null;
  errorMetadata?: JsonValueType | null;
} & JobRelations

export const JobWithRelationsSchema: z.ZodType<JobWithRelations> = JobSchema.merge(z.object({
  partAnalysis: z.lazy(() => PartAnalysisWithRelationsSchema).nullable(),
  quoteRequestLine: z.lazy(() => QuoteRequestLineWithRelationsSchema).nullable(),
  quoteRequest: z.lazy(() => QuoteRequestWithRelationsSchema).nullable(),
  company: z.lazy(() => CompanyWithRelationsSchema).nullable(),
}))

// JOB OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type JobOptionalDefaultsRelations = {
  partAnalysis?: PartAnalysisOptionalDefaultsWithRelations | null;
  quoteRequestLine?: QuoteRequestLineOptionalDefaultsWithRelations | null;
  quoteRequest?: QuoteRequestOptionalDefaultsWithRelations | null;
  company?: CompanyOptionalDefaultsWithRelations | null;
};

export type JobOptionalDefaultsWithRelations = Omit<z.infer<typeof JobOptionalDefaultsSchema>, "inputPayload" | "outputPayload" | "errorMetadata"> & {
  inputPayload?: JsonValueType | null;
  outputPayload?: JsonValueType | null;
  errorMetadata?: JsonValueType | null;
} & JobOptionalDefaultsRelations

export const JobOptionalDefaultsWithRelationsSchema: z.ZodType<JobOptionalDefaultsWithRelations> = JobOptionalDefaultsSchema.merge(z.object({
  partAnalysis: z.lazy(() => PartAnalysisOptionalDefaultsWithRelationsSchema).nullable(),
  quoteRequestLine: z.lazy(() => QuoteRequestLineOptionalDefaultsWithRelationsSchema).nullable(),
  quoteRequest: z.lazy(() => QuoteRequestOptionalDefaultsWithRelationsSchema).nullable(),
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema).nullable(),
}))

/////////////////////////////////////////
// PART ANALYTICS SCHEMA
/////////////////////////////////////////

export const PartAnalyticsSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  partVolumeMin: z.number().nullable(),
  partVolumeMax: z.number().nullable(),
  partAreaMin: z.number().nullable(),
  partAreaMax: z.number().nullable(),
  companyId: z.string(),
})

export type PartAnalytics = z.infer<typeof PartAnalyticsSchema>

// PART ANALYTICS OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const PartAnalyticsOptionalDefaultsSchema = PartAnalyticsSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type PartAnalyticsOptionalDefaults = z.infer<typeof PartAnalyticsOptionalDefaultsSchema>

// PART ANALYTICS RELATION SCHEMA
//------------------------------------------------------

export type PartAnalyticsRelations = {
  company: CompanyWithRelations;
};

export type PartAnalyticsWithRelations = z.infer<typeof PartAnalyticsSchema> & PartAnalyticsRelations

export const PartAnalyticsWithRelationsSchema: z.ZodType<PartAnalyticsWithRelations> = PartAnalyticsSchema.merge(z.object({
  company: z.lazy(() => CompanyWithRelationsSchema),
}))

// PART ANALYTICS OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type PartAnalyticsOptionalDefaultsRelations = {
  company: CompanyOptionalDefaultsWithRelations;
};

export type PartAnalyticsOptionalDefaultsWithRelations = z.infer<typeof PartAnalyticsOptionalDefaultsSchema> & PartAnalyticsOptionalDefaultsRelations

export const PartAnalyticsOptionalDefaultsWithRelationsSchema: z.ZodType<PartAnalyticsOptionalDefaultsWithRelations> = PartAnalyticsOptionalDefaultsSchema.merge(z.object({
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// MATERIAL ANALYTICS SCHEMA
/////////////////////////////////////////

export const MaterialAnalyticsSchema = z.object({
  materialGrade: MaterialGradeSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  volumetricPriceMin: z.number(),
  volumetricPriceMax: z.number(),
  companyId: z.string(),
})

export type MaterialAnalytics = z.infer<typeof MaterialAnalyticsSchema>

// MATERIAL ANALYTICS OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const MaterialAnalyticsOptionalDefaultsSchema = MaterialAnalyticsSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type MaterialAnalyticsOptionalDefaults = z.infer<typeof MaterialAnalyticsOptionalDefaultsSchema>

// MATERIAL ANALYTICS RELATION SCHEMA
//------------------------------------------------------

export type MaterialAnalyticsRelations = {
  company: CompanyWithRelations;
};

export type MaterialAnalyticsWithRelations = z.infer<typeof MaterialAnalyticsSchema> & MaterialAnalyticsRelations

export const MaterialAnalyticsWithRelationsSchema: z.ZodType<MaterialAnalyticsWithRelations> = MaterialAnalyticsSchema.merge(z.object({
  company: z.lazy(() => CompanyWithRelationsSchema),
}))

// MATERIAL ANALYTICS OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type MaterialAnalyticsOptionalDefaultsRelations = {
  company: CompanyOptionalDefaultsWithRelations;
};

export type MaterialAnalyticsOptionalDefaultsWithRelations = z.infer<typeof MaterialAnalyticsOptionalDefaultsSchema> & MaterialAnalyticsOptionalDefaultsRelations

export const MaterialAnalyticsOptionalDefaultsWithRelationsSchema: z.ZodType<MaterialAnalyticsOptionalDefaultsWithRelations> = MaterialAnalyticsOptionalDefaultsSchema.merge(z.object({
  company: z.lazy(() => CompanyOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// RESET PASSWORD TOKEN SCHEMA
/////////////////////////////////////////

export const ResetPasswordTokenSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  userId: z.string(),
})

export type ResetPasswordToken = z.infer<typeof ResetPasswordTokenSchema>

// RESET PASSWORD TOKEN OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const ResetPasswordTokenOptionalDefaultsSchema = ResetPasswordTokenSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type ResetPasswordTokenOptionalDefaults = z.infer<typeof ResetPasswordTokenOptionalDefaultsSchema>

// RESET PASSWORD TOKEN RELATION SCHEMA
//------------------------------------------------------

export type ResetPasswordTokenRelations = {
  user: UserWithRelations;
};

export type ResetPasswordTokenWithRelations = z.infer<typeof ResetPasswordTokenSchema> & ResetPasswordTokenRelations

export const ResetPasswordTokenWithRelationsSchema: z.ZodType<ResetPasswordTokenWithRelations> = ResetPasswordTokenSchema.merge(z.object({
  user: z.lazy(() => UserWithRelationsSchema),
}))

// RESET PASSWORD TOKEN OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type ResetPasswordTokenOptionalDefaultsRelations = {
  user: UserOptionalDefaultsWithRelations;
};

export type ResetPasswordTokenOptionalDefaultsWithRelations = z.infer<typeof ResetPasswordTokenOptionalDefaultsSchema> & ResetPasswordTokenOptionalDefaultsRelations

export const ResetPasswordTokenOptionalDefaultsWithRelationsSchema: z.ZodType<ResetPasswordTokenOptionalDefaultsWithRelations> = ResetPasswordTokenOptionalDefaultsSchema.merge(z.object({
  user: z.lazy(() => UserOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// O AUTH ACCOUNT SCHEMA
/////////////////////////////////////////

export const OAuthAccountSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  provider: z.string(),
  accessToken: z.string().nullable(),
  refreshToken: z.string().nullable(),
  expiresOn: z.coerce.date().nullable(),
  msTenantId: z.string().nullable(),
  userId: z.string(),
})

export type OAuthAccount = z.infer<typeof OAuthAccountSchema>

// O AUTH ACCOUNT OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const OAuthAccountOptionalDefaultsSchema = OAuthAccountSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type OAuthAccountOptionalDefaults = z.infer<typeof OAuthAccountOptionalDefaultsSchema>

// O AUTH ACCOUNT RELATION SCHEMA
//------------------------------------------------------

export type OAuthAccountRelations = {
  user: UserWithRelations;
};

export type OAuthAccountWithRelations = z.infer<typeof OAuthAccountSchema> & OAuthAccountRelations

export const OAuthAccountWithRelationsSchema: z.ZodType<OAuthAccountWithRelations> = OAuthAccountSchema.merge(z.object({
  user: z.lazy(() => UserWithRelationsSchema),
}))

// O AUTH ACCOUNT OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type OAuthAccountOptionalDefaultsRelations = {
  user: UserOptionalDefaultsWithRelations;
};

export type OAuthAccountOptionalDefaultsWithRelations = z.infer<typeof OAuthAccountOptionalDefaultsSchema> & OAuthAccountOptionalDefaultsRelations

export const OAuthAccountOptionalDefaultsWithRelationsSchema: z.ZodType<OAuthAccountOptionalDefaultsWithRelations> = OAuthAccountOptionalDefaultsSchema.merge(z.object({
  user: z.lazy(() => UserOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// PKCE CHALLENGE SCHEMA
/////////////////////////////////////////

export const PkceChallengeSchema = z.object({
  nonce: z.string(),
  createdAt: z.coerce.date(),
  verifier: z.string(),
  expiresAt: z.coerce.date(),
})

export type PkceChallenge = z.infer<typeof PkceChallengeSchema>

// PKCE CHALLENGE OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const PkceChallengeOptionalDefaultsSchema = PkceChallengeSchema.merge(z.object({
  createdAt: z.coerce.date().optional(),
}))

export type PkceChallengeOptionalDefaults = z.infer<typeof PkceChallengeOptionalDefaultsSchema>

/////////////////////////////////////////
// MCP AUTHORIZATION CODE SCHEMA
/////////////////////////////////////////

export const McpAuthorizationCodeSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  code: z.string(),
  codeChallenge: z.string(),
  redirectUri: z.string(),
  expiresAt: z.coerce.date(),
  userId: z.string(),
})

export type McpAuthorizationCode = z.infer<typeof McpAuthorizationCodeSchema>

// MCP AUTHORIZATION CODE OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const McpAuthorizationCodeOptionalDefaultsSchema = McpAuthorizationCodeSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
}))

export type McpAuthorizationCodeOptionalDefaults = z.infer<typeof McpAuthorizationCodeOptionalDefaultsSchema>

// MCP AUTHORIZATION CODE RELATION SCHEMA
//------------------------------------------------------

export type McpAuthorizationCodeRelations = {
  user: UserWithRelations;
};

export type McpAuthorizationCodeWithRelations = z.infer<typeof McpAuthorizationCodeSchema> & McpAuthorizationCodeRelations

export const McpAuthorizationCodeWithRelationsSchema: z.ZodType<McpAuthorizationCodeWithRelations> = McpAuthorizationCodeSchema.merge(z.object({
  user: z.lazy(() => UserWithRelationsSchema),
}))

// MCP AUTHORIZATION CODE OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type McpAuthorizationCodeOptionalDefaultsRelations = {
  user: UserOptionalDefaultsWithRelations;
};

export type McpAuthorizationCodeOptionalDefaultsWithRelations = z.infer<typeof McpAuthorizationCodeOptionalDefaultsSchema> & McpAuthorizationCodeOptionalDefaultsRelations

export const McpAuthorizationCodeOptionalDefaultsWithRelationsSchema: z.ZodType<McpAuthorizationCodeOptionalDefaultsWithRelations> = McpAuthorizationCodeOptionalDefaultsSchema.merge(z.object({
  user: z.lazy(() => UserOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// QUOTE REQUEST NOTIFICATIONS DELAY SCHEMA
/////////////////////////////////////////

export const QuoteRequestNotificationsDelaySchema = z.object({
  quoteRequestStatus: QuoteRequestStatusSchema,
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  delay: z.number().int(),
  userSettingsId: z.string(),
})

export type QuoteRequestNotificationsDelay = z.infer<typeof QuoteRequestNotificationsDelaySchema>

// QUOTE REQUEST NOTIFICATIONS DELAY OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const QuoteRequestNotificationsDelayOptionalDefaultsSchema = QuoteRequestNotificationsDelaySchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  delay: z.number().int().optional(),
}))

export type QuoteRequestNotificationsDelayOptionalDefaults = z.infer<typeof QuoteRequestNotificationsDelayOptionalDefaultsSchema>

// QUOTE REQUEST NOTIFICATIONS DELAY RELATION SCHEMA
//------------------------------------------------------

export type QuoteRequestNotificationsDelayRelations = {
  userSettings: UserSettingsWithRelations;
};

export type QuoteRequestNotificationsDelayWithRelations = z.infer<typeof QuoteRequestNotificationsDelaySchema> & QuoteRequestNotificationsDelayRelations

export const QuoteRequestNotificationsDelayWithRelationsSchema: z.ZodType<QuoteRequestNotificationsDelayWithRelations> = QuoteRequestNotificationsDelaySchema.merge(z.object({
  userSettings: z.lazy(() => UserSettingsWithRelationsSchema),
}))

// QUOTE REQUEST NOTIFICATIONS DELAY OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type QuoteRequestNotificationsDelayOptionalDefaultsRelations = {
  userSettings: UserSettingsOptionalDefaultsWithRelations;
};

export type QuoteRequestNotificationsDelayOptionalDefaultsWithRelations = z.infer<typeof QuoteRequestNotificationsDelayOptionalDefaultsSchema> & QuoteRequestNotificationsDelayOptionalDefaultsRelations

export const QuoteRequestNotificationsDelayOptionalDefaultsWithRelationsSchema: z.ZodType<QuoteRequestNotificationsDelayOptionalDefaultsWithRelations> = QuoteRequestNotificationsDelayOptionalDefaultsSchema.merge(z.object({
  userSettings: z.lazy(() => UserSettingsOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// SEARCH SCHEMA
/////////////////////////////////////////

export const SearchSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  query: z.string(),
  userId: z.string(),
})

export type Search = z.infer<typeof SearchSchema>

// SEARCH OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const SearchOptionalDefaultsSchema = SearchSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
}))

export type SearchOptionalDefaults = z.infer<typeof SearchOptionalDefaultsSchema>

// SEARCH RELATION SCHEMA
//------------------------------------------------------

export type SearchRelations = {
  user: UserWithRelations;
};

export type SearchWithRelations = z.infer<typeof SearchSchema> & SearchRelations

export const SearchWithRelationsSchema: z.ZodType<SearchWithRelations> = SearchSchema.merge(z.object({
  user: z.lazy(() => UserWithRelationsSchema),
}))

// SEARCH OPTIONAL DEFAULTS RELATION SCHEMA
//------------------------------------------------------

export type SearchOptionalDefaultsRelations = {
  user: UserOptionalDefaultsWithRelations;
};

export type SearchOptionalDefaultsWithRelations = z.infer<typeof SearchOptionalDefaultsSchema> & SearchOptionalDefaultsRelations

export const SearchOptionalDefaultsWithRelationsSchema: z.ZodType<SearchOptionalDefaultsWithRelations> = SearchOptionalDefaultsSchema.merge(z.object({
  user: z.lazy(() => UserOptionalDefaultsWithRelationsSchema),
}))

/////////////////////////////////////////
// INBOUND EMAIL SCHEMA
/////////////////////////////////////////

export const InboundEmailSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  emailId: z.string(),
  svixId: z.string(),
})

export type InboundEmail = z.infer<typeof InboundEmailSchema>

// INBOUND EMAIL OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const InboundEmailOptionalDefaultsSchema = InboundEmailSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
}))

export type InboundEmailOptionalDefaults = z.infer<typeof InboundEmailOptionalDefaultsSchema>

/////////////////////////////////////////
// SETTINGS AUDIT LOG SCHEMA
/////////////////////////////////////////

export const SettingsAuditLogSchema = z.object({
  operation: AuditOperationSchema,
  actorType: AuditActorTypeSchema.nullable(),
  id: z.string().uuid(),
  createdAt: z.coerce.date(),
  tableName: z.string(),
  recordId: z.string(),
  companyId: z.string().nullable(),
  oldData: JsonValueSchema.nullable(),
  newData: JsonValueSchema.nullable(),
  dbRole: z.string(),
  actorId: z.string().nullable(),
  actorLabel: z.string().nullable(),
})

export type SettingsAuditLog = z.infer<typeof SettingsAuditLogSchema>

// SETTINGS AUDIT LOG OPTIONAL DEFAULTS SCHEMA
//------------------------------------------------------

export const SettingsAuditLogOptionalDefaultsSchema = SettingsAuditLogSchema.merge(z.object({
  id: z.string().uuid().optional(),
  createdAt: z.coerce.date().optional(),
}))

export type SettingsAuditLogOptionalDefaults = z.infer<typeof SettingsAuditLogOptionalDefaultsSchema>
